/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as CreateOrganizationRouteImport } from './routes/create-organization'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SelectOrganizationRouteImport } from './routes/select-organization'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedBalancesRouteImport } from './routes/_authenticated/balances'
import { Route as AuthenticatedDisputesRouteImport } from './routes/_authenticated/disputes'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees'
import { Route as AuthenticatedPaymentsRouteImport } from './routes/_authenticated/payments'
import { Route as AuthenticatedPayoutsRouteImport } from './routes/_authenticated/payouts'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedEmployeesIndexRouteImport } from './routes/_authenticated/employees/index'
import { Route as AuthenticatedEmployeesIdRouteImport } from './routes/_authenticated/employees/$id'
import { Route as AuthenticatedEmployeesManageRolesRouteImport } from './routes/_authenticated/employees.manage-roles'
import { Route as AuthenticatedEmployeesNewRouteImport } from './routes/_authenticated/employees.new'
import { Route as AuthenticatedEmployeesShiftsRouteImport } from './routes/_authenticated/employees/shifts'
import { Route as AuthenticatedLocationsIndexRouteImport } from './routes/_authenticated/locations.index'
import { Route as AuthenticatedLocationsIdRouteImport } from './routes/_authenticated/locations/$id'
import { Route as AuthenticatedLocationsNewRouteImport } from './routes/_authenticated/locations/new'
import { Route as AuthenticatedMenusIndexRouteImport } from './routes/_authenticated/menus.index'
import { Route as AuthenticatedMenusMenuIdRouteImport } from './routes/_authenticated/menus/$menuId'
import { Route as AuthenticatedMenusEmptyRouteImport } from './routes/_authenticated/menus/empty'
import { Route as AuthenticatedMenusNewRouteImport } from './routes/_authenticated/menus/new'
import { Route as AuthenticatedPaymentsPaymentIdRouteImport } from './routes/_authenticated/payments.$paymentId'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedReportsCashOperationsRouteImport } from './routes/_authenticated/reports/cash-operations'
import { Route as AuthenticatedReportsDetailedOrderTypeReportRouteImport } from './routes/_authenticated/reports/detailed-order-type-report'
import { Route as AuthenticatedReportsEmployeeEarningsSummaryRouteImport } from './routes/_authenticated/reports/employee-earnings-summary'
import { Route as AuthenticatedReportsEmployeePerformanceRouteImport } from './routes/_authenticated/reports/employee-performance'
import { Route as AuthenticatedReportsEmployeeSalesSummaryRouteImport } from './routes/_authenticated/reports/employee-sales-summary'
import { Route as AuthenticatedReportsEmployeeTipReportRouteImport } from './routes/_authenticated/reports/employee-tip-report'
import { Route as AuthenticatedReportsLaborSummaryRouteImport } from './routes/_authenticated/reports/labor-summary'
import { Route as AuthenticatedReportsMenuPerformanceRouteImport } from './routes/_authenticated/reports/menu-performance'
import { Route as AuthenticatedReportsSalesByStaffSummaryRouteImport } from './routes/_authenticated/reports/sales-by-staff-summary'
import { Route as AuthenticatedReportsTaxCollectedReportRouteImport } from './routes/_authenticated/reports/tax-collected-report'
import { Route as AuthenticatedReportsTransactionAnalysisRouteImport } from './routes/_authenticated/reports/transaction-analysis'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsAccountManagementRouteImport } from './routes/_authenticated/settings/account-management'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsBusinessInformationRouteImport } from './routes/_authenticated/settings/business-information'
import { Route as AuthenticatedSettingsMenusRouteImport } from './routes/_authenticated/settings/menus'
import { Route as AuthenticatedSettingsOrganizationRouteImport } from './routes/_authenticated/settings/organization'
import { Route as AuthenticatedSettingsPaymentAccountRouteImport } from './routes/_authenticated/settings/payment-account'
import { Route as AuthenticatedSettingsSalesCategoriesRouteImport } from './routes/_authenticated/settings/sales-categories'
import { Route as AuthenticatedSettingsTaxCategoriesRouteImport } from './routes/_authenticated/settings/tax-categories'
import { Route as AuthenticatedSettingsTaxRatesRouteImport } from './routes/_authenticated/settings/tax-rates'
import { Route as AuthenticatedSettingsTerminalsRouteImport } from './routes/_authenticated/settings/terminals'
import { Route as AuthenticatedSettingsUsageRouteImport } from './routes/_authenticated/settings/usage'
import { Route as AuthenticatedEmployeesIdToggleStatusRouteImport } from './routes/_authenticated/employees/$id.toggle-status'
import { Route as AuthenticatedEmployeesNewCreateRoleRouteImport } from './routes/_authenticated/employees.new.create-role'
import { Route as AuthenticatedEmployeesShiftsNewRouteImport } from './routes/_authenticated/employees/shifts.new'
import { Route as AuthenticatedLocationsIdDevicesRouteImport } from './routes/_authenticated/locations/$id/devices'
import { Route as AuthenticatedLocationsIdDiscountsRouteImport } from './routes/_authenticated/locations/$id/discounts'
import { Route as AuthenticatedLocationsIdEditRouteImport } from './routes/_authenticated/locations/$id/edit'
import { Route as AuthenticatedLocationsIdEndOfDayRouteImport } from './routes/_authenticated/locations/$id/end-of-day'
import { Route as AuthenticatedLocationsIdKdsDevicesRouteImport } from './routes/_authenticated/locations/$id/kds-devices'
import { Route as AuthenticatedLocationsIdOnlineOrderingRouteImport } from './routes/_authenticated/locations/$id/online-ordering'
import { Route as AuthenticatedLocationsIdProfileRouteImport } from './routes/_authenticated/locations/$id/profile'
import { Route as AuthenticatedLocationsIdReceiptsRouteImport } from './routes/_authenticated/locations/$id/receipts'
import { Route as AuthenticatedLocationsIdStationsRouteImport } from './routes/_authenticated/locations/$id/stations'
import { Route as AuthenticatedLocationsIdTipsRouteImport } from './routes/_authenticated/locations/$id/tips'
import { Route as AuthenticatedLocationsIdVoidsAndRefundsRouteImport } from './routes/_authenticated/locations/$id/voids-and-refunds'
import { Route as AuthenticatedMenusMenuIdIndexRouteImport } from './routes/_authenticated/menus/$menuId/index'
import { Route as AuthenticatedMenusMenuIdCategoriesRouteImport } from './routes/_authenticated/menus/$menuId/categories'
import { Route as AuthenticatedMenusMenuIdDeleteRouteImport } from './routes/_authenticated/menus/$menuId.delete'
import { Route as AuthenticatedMenusMenuIdEditRouteImport } from './routes/_authenticated/menus/$menuId.edit'
import { Route as AuthenticatedMenusMenuIdItemsRouteImport } from './routes/_authenticated/menus/$menuId/items'
import { Route as AuthenticatedMenusMenuIdModifiersRouteImport } from './routes/_authenticated/menus/$menuId/modifiers'
import { Route as AuthenticatedSettingsAccountSplatRouteImport } from './routes/_authenticated/settings/account.$'
import { Route as AuthenticatedSettingsSalesCategoriesNewRouteImport } from './routes/_authenticated/settings/sales-categories/new'
import { Route as AuthenticatedSettingsTaxCategoriesNewRouteImport } from './routes/_authenticated/settings/tax-categories/new'
import { Route as AuthenticatedEmployeesIdEditFieldRouteImport } from './routes/_authenticated/employees/$id.edit.$field'
import { Route as AuthenticatedEmployeesShiftsShiftIdDeleteRouteImport } from './routes/_authenticated/employees/shifts.$shiftId.delete'
import { Route as AuthenticatedEmployeesShiftsShiftIdEditRouteImport } from './routes/_authenticated/employees/shifts.$shiftId.edit'
import { Route as AuthenticatedLocationsIdDevicesDeviceIdRouteImport } from './routes/_authenticated/locations/$id/devices/$deviceId'
import { Route as AuthenticatedLocationsIdDiscountsNewRouteImport } from './routes/_authenticated/locations/$id/discounts/new'
import { Route as AuthenticatedLocationsIdDiscountsSettingsRouteImport } from './routes/_authenticated/locations/$id/discounts.settings'
import { Route as AuthenticatedLocationsIdEndOfDayBusinessReportRouteImport } from './routes/_authenticated/locations/$id/end-of-day/business-report'
import { Route as AuthenticatedLocationsIdEndOfDayEmployeeReportRouteImport } from './routes/_authenticated/locations/$id/end-of-day/employee-report'
import { Route as AuthenticatedLocationsIdReceiptsCustomerBillRouteImport } from './routes/_authenticated/locations/$id/receipts/customer-bill'
import { Route as AuthenticatedLocationsIdReceiptsCustomerReceiptRouteImport } from './routes/_authenticated/locations/$id/receipts/customer-receipt'
import { Route as AuthenticatedLocationsIdReceiptsKitchenTicketRouteImport } from './routes/_authenticated/locations/$id/receipts/kitchen-ticket'
import { Route as AuthenticatedLocationsIdStationsNewRouteImport } from './routes/_authenticated/locations/$id/stations.new'
import { Route as AuthenticatedMenusMenuIdCategoriesIndexRouteImport } from './routes/_authenticated/menus/$menuId/categories/index'
import { Route as AuthenticatedMenusMenuIdCategoriesCategoryIdRouteImport } from './routes/_authenticated/menus/$menuId/categories/$categoryId'
import { Route as AuthenticatedMenusMenuIdCategoriesNewRouteImport } from './routes/_authenticated/menus/$menuId/categories/new'
import { Route as AuthenticatedMenusMenuIdItemsIndexRouteImport } from './routes/_authenticated/menus/$menuId/items/index'
import { Route as AuthenticatedMenusMenuIdItemsItemIdRouteImport } from './routes/_authenticated/menus/$menuId/items/$itemId'
import { Route as AuthenticatedMenusMenuIdItemsNewRouteImport } from './routes/_authenticated/menus/$menuId/items/new'
import { Route as AuthenticatedMenusMenuIdModifiersIndexRouteImport } from './routes/_authenticated/menus/$menuId/modifiers/index'
import { Route as AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteImport } from './routes/_authenticated/menus/$menuId/modifiers/$modifierGroupId'
import { Route as AuthenticatedMenusMenuIdModifiersNewRouteImport } from './routes/_authenticated/menus/$menuId/modifiers/new'
import { Route as AuthenticatedSettingsBusinessInformationEditTypeRouteImport } from './routes/_authenticated/settings/business-information/edit.$type'
import { Route as AuthenticatedSettingsSalesCategoriesCategoryIdEditRouteImport } from './routes/_authenticated/settings/sales-categories/$categoryId.edit'
import { Route as AuthenticatedSettingsSalesCategoriesIdDeleteRouteImport } from './routes/_authenticated/settings/sales-categories.$id.delete'
import { Route as AuthenticatedSettingsTaxCategoriesCategoryIdEditRouteImport } from './routes/_authenticated/settings/tax-categories/$categoryId.edit'
import { Route as AuthenticatedSettingsTaxCategoriesIdDeleteRouteImport } from './routes/_authenticated/settings/tax-categories.$id.delete'
import { Route as AuthenticatedSettingsTerminalsOrderLocationIdRouteImport } from './routes/_authenticated/settings/terminals.order.$locationId'
import { Route as AuthenticatedSettingsTerminalsRegisterLocationIdRouteImport } from './routes/_authenticated/settings/terminals.register.$locationId'
import { Route as AuthenticatedSettingsTerminalsSetupLocationIdRouteImport } from './routes/_authenticated/settings/terminals.setup.$locationId'
import { Route as AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRouteImport } from './routes/_authenticated/locations/$id/devices/$deviceId.add-terminal'
import { Route as AuthenticatedLocationsIdDevicesDeviceIdDeleteRouteImport } from './routes/_authenticated/locations/$id/devices/$deviceId.delete'
import { Route as AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRouteImport } from './routes/_authenticated/locations/$id/devices/$deviceId.remove-terminal'
import { Route as AuthenticatedLocationsIdDiscountsDiscountIdDeleteRouteImport } from './routes/_authenticated/locations/$id/discounts/$discountId.delete'
import { Route as AuthenticatedLocationsIdDiscountsDiscountIdEditRouteImport } from './routes/_authenticated/locations/$id/discounts/$discountId.edit'
import { Route as AuthenticatedLocationsIdProfileEditFieldRouteImport } from './routes/_authenticated/locations/$id/profile.edit.$field'
import { Route as AuthenticatedLocationsIdStationsStationIdEditRouteImport } from './routes/_authenticated/locations/$id/stations.$stationId.edit'
import { Route as AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRouteImport } from './routes/_authenticated/menus/$menuId/categories/$categoryId.delete'
import { Route as AuthenticatedMenusMenuIdCategoriesCategoryIdEditRouteImport } from './routes/_authenticated/menus/$menuId/categories/$categoryId.edit'
import { Route as AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRouteImport } from './routes/_authenticated/menus/$menuId/items/$itemId.create-sales-category'
import { Route as AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRouteImport } from './routes/_authenticated/menus/$menuId/items/$itemId.create-tax-category'
import { Route as AuthenticatedMenusMenuIdItemsItemIdDeleteRouteImport } from './routes/_authenticated/menus/$menuId/items/$itemId.delete'
import { Route as AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRouteImport } from './routes/_authenticated/menus/$menuId/items/new.create-sales-category'
import { Route as AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRouteImport } from './routes/_authenticated/menus/$menuId/items/new.create-tax-category'
import { Route as AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRouteImport } from './routes/_authenticated/menus/$menuId/modifiers/$modifierGroupId.delete'
import { Route as AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRouteImport } from './routes/_authenticated/menus/$menuId/modifiers/$modifierGroupId.duplicate'
import { Route as AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRouteImport } from './routes/_authenticated/settings/sales-categories.$id.delete.create-category'
import { Route as AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRouteImport } from './routes/_authenticated/settings/tax-categories.$id.delete.create-category'
import { Route as AuthenticatedSettingsTerminalsReadersReaderIdDeleteRouteImport } from './routes/_authenticated/settings/terminals.readers.$readerId.delete'
import { Route as AuthenticatedSettingsTerminalsReadersReaderIdEditRouteImport } from './routes/_authenticated/settings/terminals.readers.$readerId.edit'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateOrganizationRoute = CreateOrganizationRouteImport.update({
  id: '/create-organization',
  path: '/create-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectOrganizationRoute = SelectOrganizationRouteImport.update({
  id: '/select-organization',
  path: '/select-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBalancesRoute = AuthenticatedBalancesRouteImport.update({
  id: '/balances',
  path: '/balances',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDisputesRoute = AuthenticatedDisputesRouteImport.update({
  id: '/disputes',
  path: '/disputes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPaymentsRoute = AuthenticatedPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPayoutsRoute = AuthenticatedPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmployeesIndexRoute =
  AuthenticatedEmployeesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmployeesRoute,
  } as any)
const AuthenticatedEmployeesIdRoute =
  AuthenticatedEmployeesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedEmployeesRoute,
  } as any)
const AuthenticatedEmployeesManageRolesRoute =
  AuthenticatedEmployeesManageRolesRouteImport.update({
    id: '/manage-roles',
    path: '/manage-roles',
    getParentRoute: () => AuthenticatedEmployeesRoute,
  } as any)
const AuthenticatedEmployeesNewRoute =
  AuthenticatedEmployeesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedEmployeesRoute,
  } as any)
const AuthenticatedEmployeesShiftsRoute =
  AuthenticatedEmployeesShiftsRouteImport.update({
    id: '/shifts',
    path: '/shifts',
    getParentRoute: () => AuthenticatedEmployeesRoute,
  } as any)
const AuthenticatedLocationsIndexRoute =
  AuthenticatedLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsIdRoute =
  AuthenticatedLocationsIdRouteImport.update({
    id: '/locations/$id',
    path: '/locations/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsNewRoute =
  AuthenticatedLocationsNewRouteImport.update({
    id: '/locations/new',
    path: '/locations/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMenusIndexRoute = AuthenticatedMenusIndexRouteImport.update({
  id: '/menus/',
  path: '/menus/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMenusMenuIdRoute =
  AuthenticatedMenusMenuIdRouteImport.update({
    id: '/menus/$menuId',
    path: '/menus/$menuId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMenusEmptyRoute = AuthenticatedMenusEmptyRouteImport.update({
  id: '/menus/empty',
  path: '/menus/empty',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMenusNewRoute = AuthenticatedMenusNewRouteImport.update({
  id: '/menus/new',
  path: '/menus/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPaymentsPaymentIdRoute =
  AuthenticatedPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => AuthenticatedPaymentsRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsCashOperationsRoute =
  AuthenticatedReportsCashOperationsRouteImport.update({
    id: '/cash-operations',
    path: '/cash-operations',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsDetailedOrderTypeReportRoute =
  AuthenticatedReportsDetailedOrderTypeReportRouteImport.update({
    id: '/detailed-order-type-report',
    path: '/detailed-order-type-report',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsEmployeeEarningsSummaryRoute =
  AuthenticatedReportsEmployeeEarningsSummaryRouteImport.update({
    id: '/employee-earnings-summary',
    path: '/employee-earnings-summary',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsEmployeePerformanceRoute =
  AuthenticatedReportsEmployeePerformanceRouteImport.update({
    id: '/employee-performance',
    path: '/employee-performance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsEmployeeSalesSummaryRoute =
  AuthenticatedReportsEmployeeSalesSummaryRouteImport.update({
    id: '/employee-sales-summary',
    path: '/employee-sales-summary',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsEmployeeTipReportRoute =
  AuthenticatedReportsEmployeeTipReportRouteImport.update({
    id: '/employee-tip-report',
    path: '/employee-tip-report',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsLaborSummaryRoute =
  AuthenticatedReportsLaborSummaryRouteImport.update({
    id: '/labor-summary',
    path: '/labor-summary',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsMenuPerformanceRoute =
  AuthenticatedReportsMenuPerformanceRouteImport.update({
    id: '/menu-performance',
    path: '/menu-performance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSalesByStaffSummaryRoute =
  AuthenticatedReportsSalesByStaffSummaryRouteImport.update({
    id: '/sales-by-staff-summary',
    path: '/sales-by-staff-summary',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTaxCollectedReportRoute =
  AuthenticatedReportsTaxCollectedReportRouteImport.update({
    id: '/tax-collected-report',
    path: '/tax-collected-report',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTransactionAnalysisRoute =
  AuthenticatedReportsTransactionAnalysisRouteImport.update({
    id: '/transaction-analysis',
    path: '/transaction-analysis',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAccountManagementRoute =
  AuthenticatedSettingsAccountManagementRouteImport.update({
    id: '/account-management',
    path: '/account-management',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBusinessInformationRoute =
  AuthenticatedSettingsBusinessInformationRouteImport.update({
    id: '/business-information',
    path: '/business-information',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMenusRoute =
  AuthenticatedSettingsMenusRouteImport.update({
    id: '/menus',
    path: '/menus',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrganizationRoute =
  AuthenticatedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPaymentAccountRoute =
  AuthenticatedSettingsPaymentAccountRouteImport.update({
    id: '/payment-account',
    path: '/payment-account',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSalesCategoriesRoute =
  AuthenticatedSettingsSalesCategoriesRouteImport.update({
    id: '/sales-categories',
    path: '/sales-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTaxCategoriesRoute =
  AuthenticatedSettingsTaxCategoriesRouteImport.update({
    id: '/tax-categories',
    path: '/tax-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTaxRatesRoute =
  AuthenticatedSettingsTaxRatesRouteImport.update({
    id: '/tax-rates',
    path: '/tax-rates',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTerminalsRoute =
  AuthenticatedSettingsTerminalsRouteImport.update({
    id: '/terminals',
    path: '/terminals',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsUsageRoute =
  AuthenticatedSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedEmployeesIdToggleStatusRoute =
  AuthenticatedEmployeesIdToggleStatusRouteImport.update({
    id: '/toggle-status',
    path: '/toggle-status',
    getParentRoute: () => AuthenticatedEmployeesIdRoute,
  } as any)
const AuthenticatedEmployeesNewCreateRoleRoute =
  AuthenticatedEmployeesNewCreateRoleRouteImport.update({
    id: '/create-role',
    path: '/create-role',
    getParentRoute: () => AuthenticatedEmployeesNewRoute,
  } as any)
const AuthenticatedEmployeesShiftsNewRoute =
  AuthenticatedEmployeesShiftsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedEmployeesShiftsRoute,
  } as any)
const AuthenticatedLocationsIdDevicesRoute =
  AuthenticatedLocationsIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdDiscountsRoute =
  AuthenticatedLocationsIdDiscountsRouteImport.update({
    id: '/discounts',
    path: '/discounts',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdEditRoute =
  AuthenticatedLocationsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdEndOfDayRoute =
  AuthenticatedLocationsIdEndOfDayRouteImport.update({
    id: '/end-of-day',
    path: '/end-of-day',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdKdsDevicesRoute =
  AuthenticatedLocationsIdKdsDevicesRouteImport.update({
    id: '/kds-devices',
    path: '/kds-devices',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdOnlineOrderingRoute =
  AuthenticatedLocationsIdOnlineOrderingRouteImport.update({
    id: '/online-ordering',
    path: '/online-ordering',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdProfileRoute =
  AuthenticatedLocationsIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdReceiptsRoute =
  AuthenticatedLocationsIdReceiptsRouteImport.update({
    id: '/receipts',
    path: '/receipts',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdStationsRoute =
  AuthenticatedLocationsIdStationsRouteImport.update({
    id: '/stations',
    path: '/stations',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdTipsRoute =
  AuthenticatedLocationsIdTipsRouteImport.update({
    id: '/tips',
    path: '/tips',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdVoidsAndRefundsRoute =
  AuthenticatedLocationsIdVoidsAndRefundsRouteImport.update({
    id: '/voids-and-refunds',
    path: '/voids-and-refunds',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedMenusMenuIdIndexRoute =
  AuthenticatedMenusMenuIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesRoute =
  AuthenticatedMenusMenuIdCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedMenusMenuIdDeleteRoute =
  AuthenticatedMenusMenuIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedMenusMenuIdEditRoute =
  AuthenticatedMenusMenuIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsRoute =
  AuthenticatedMenusMenuIdItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersRoute =
  AuthenticatedMenusMenuIdModifiersRouteImport.update({
    id: '/modifiers',
    path: '/modifiers',
    getParentRoute: () => AuthenticatedMenusMenuIdRoute,
  } as any)
const AuthenticatedSettingsAccountSplatRoute =
  AuthenticatedSettingsAccountSplatRouteImport.update({
    id: '/account/$',
    path: '/account/$',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSalesCategoriesNewRoute =
  AuthenticatedSettingsSalesCategoriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSettingsSalesCategoriesRoute,
  } as any)
const AuthenticatedSettingsTaxCategoriesNewRoute =
  AuthenticatedSettingsTaxCategoriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSettingsTaxCategoriesRoute,
  } as any)
const AuthenticatedEmployeesIdEditFieldRoute =
  AuthenticatedEmployeesIdEditFieldRouteImport.update({
    id: '/edit/$field',
    path: '/edit/$field',
    getParentRoute: () => AuthenticatedEmployeesIdRoute,
  } as any)
const AuthenticatedEmployeesShiftsShiftIdDeleteRoute =
  AuthenticatedEmployeesShiftsShiftIdDeleteRouteImport.update({
    id: '/$shiftId/delete',
    path: '/$shiftId/delete',
    getParentRoute: () => AuthenticatedEmployeesShiftsRoute,
  } as any)
const AuthenticatedEmployeesShiftsShiftIdEditRoute =
  AuthenticatedEmployeesShiftsShiftIdEditRouteImport.update({
    id: '/$shiftId/edit',
    path: '/$shiftId/edit',
    getParentRoute: () => AuthenticatedEmployeesShiftsRoute,
  } as any)
const AuthenticatedLocationsIdDevicesDeviceIdRoute =
  AuthenticatedLocationsIdDevicesDeviceIdRouteImport.update({
    id: '/$deviceId',
    path: '/$deviceId',
    getParentRoute: () => AuthenticatedLocationsIdDevicesRoute,
  } as any)
const AuthenticatedLocationsIdDiscountsNewRoute =
  AuthenticatedLocationsIdDiscountsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedLocationsIdDiscountsRoute,
  } as any)
const AuthenticatedLocationsIdDiscountsSettingsRoute =
  AuthenticatedLocationsIdDiscountsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedLocationsIdDiscountsRoute,
  } as any)
const AuthenticatedLocationsIdEndOfDayBusinessReportRoute =
  AuthenticatedLocationsIdEndOfDayBusinessReportRouteImport.update({
    id: '/business-report',
    path: '/business-report',
    getParentRoute: () => AuthenticatedLocationsIdEndOfDayRoute,
  } as any)
const AuthenticatedLocationsIdEndOfDayEmployeeReportRoute =
  AuthenticatedLocationsIdEndOfDayEmployeeReportRouteImport.update({
    id: '/employee-report',
    path: '/employee-report',
    getParentRoute: () => AuthenticatedLocationsIdEndOfDayRoute,
  } as any)
const AuthenticatedLocationsIdReceiptsCustomerBillRoute =
  AuthenticatedLocationsIdReceiptsCustomerBillRouteImport.update({
    id: '/customer-bill',
    path: '/customer-bill',
    getParentRoute: () => AuthenticatedLocationsIdReceiptsRoute,
  } as any)
const AuthenticatedLocationsIdReceiptsCustomerReceiptRoute =
  AuthenticatedLocationsIdReceiptsCustomerReceiptRouteImport.update({
    id: '/customer-receipt',
    path: '/customer-receipt',
    getParentRoute: () => AuthenticatedLocationsIdReceiptsRoute,
  } as any)
const AuthenticatedLocationsIdReceiptsKitchenTicketRoute =
  AuthenticatedLocationsIdReceiptsKitchenTicketRouteImport.update({
    id: '/kitchen-ticket',
    path: '/kitchen-ticket',
    getParentRoute: () => AuthenticatedLocationsIdReceiptsRoute,
  } as any)
const AuthenticatedLocationsIdStationsNewRoute =
  AuthenticatedLocationsIdStationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedLocationsIdStationsRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesIndexRoute =
  AuthenticatedMenusMenuIdCategoriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMenusMenuIdCategoriesRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesCategoryIdRoute =
  AuthenticatedMenusMenuIdCategoriesCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AuthenticatedMenusMenuIdCategoriesRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesNewRoute =
  AuthenticatedMenusMenuIdCategoriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMenusMenuIdCategoriesRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsIndexRoute =
  AuthenticatedMenusMenuIdItemsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsItemIdRoute =
  AuthenticatedMenusMenuIdItemsItemIdRouteImport.update({
    id: '/$itemId',
    path: '/$itemId',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsNewRoute =
  AuthenticatedMenusMenuIdItemsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersIndexRoute =
  AuthenticatedMenusMenuIdModifiersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMenusMenuIdModifiersRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute =
  AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteImport.update({
    id: '/$modifierGroupId',
    path: '/$modifierGroupId',
    getParentRoute: () => AuthenticatedMenusMenuIdModifiersRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersNewRoute =
  AuthenticatedMenusMenuIdModifiersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMenusMenuIdModifiersRoute,
  } as any)
const AuthenticatedSettingsBusinessInformationEditTypeRoute =
  AuthenticatedSettingsBusinessInformationEditTypeRouteImport.update({
    id: '/edit/$type',
    path: '/edit/$type',
    getParentRoute: () => AuthenticatedSettingsBusinessInformationRoute,
  } as any)
const AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute =
  AuthenticatedSettingsSalesCategoriesCategoryIdEditRouteImport.update({
    id: '/$categoryId/edit',
    path: '/$categoryId/edit',
    getParentRoute: () => AuthenticatedSettingsSalesCategoriesRoute,
  } as any)
const AuthenticatedSettingsSalesCategoriesIdDeleteRoute =
  AuthenticatedSettingsSalesCategoriesIdDeleteRouteImport.update({
    id: '/$id/delete',
    path: '/$id/delete',
    getParentRoute: () => AuthenticatedSettingsSalesCategoriesRoute,
  } as any)
const AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute =
  AuthenticatedSettingsTaxCategoriesCategoryIdEditRouteImport.update({
    id: '/$categoryId/edit',
    path: '/$categoryId/edit',
    getParentRoute: () => AuthenticatedSettingsTaxCategoriesRoute,
  } as any)
const AuthenticatedSettingsTaxCategoriesIdDeleteRoute =
  AuthenticatedSettingsTaxCategoriesIdDeleteRouteImport.update({
    id: '/$id/delete',
    path: '/$id/delete',
    getParentRoute: () => AuthenticatedSettingsTaxCategoriesRoute,
  } as any)
const AuthenticatedSettingsTerminalsOrderLocationIdRoute =
  AuthenticatedSettingsTerminalsOrderLocationIdRouteImport.update({
    id: '/order/$locationId',
    path: '/order/$locationId',
    getParentRoute: () => AuthenticatedSettingsTerminalsRoute,
  } as any)
const AuthenticatedSettingsTerminalsRegisterLocationIdRoute =
  AuthenticatedSettingsTerminalsRegisterLocationIdRouteImport.update({
    id: '/register/$locationId',
    path: '/register/$locationId',
    getParentRoute: () => AuthenticatedSettingsTerminalsRoute,
  } as any)
const AuthenticatedSettingsTerminalsSetupLocationIdRoute =
  AuthenticatedSettingsTerminalsSetupLocationIdRouteImport.update({
    id: '/setup/$locationId',
    path: '/setup/$locationId',
    getParentRoute: () => AuthenticatedSettingsTerminalsRoute,
  } as any)
const AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute =
  AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRouteImport.update({
    id: '/add-terminal',
    path: '/add-terminal',
    getParentRoute: () => AuthenticatedLocationsIdDevicesDeviceIdRoute,
  } as any)
const AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute =
  AuthenticatedLocationsIdDevicesDeviceIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthenticatedLocationsIdDevicesDeviceIdRoute,
  } as any)
const AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute =
  AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRouteImport.update({
    id: '/remove-terminal',
    path: '/remove-terminal',
    getParentRoute: () => AuthenticatedLocationsIdDevicesDeviceIdRoute,
  } as any)
const AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute =
  AuthenticatedLocationsIdDiscountsDiscountIdDeleteRouteImport.update({
    id: '/$discountId/delete',
    path: '/$discountId/delete',
    getParentRoute: () => AuthenticatedLocationsIdDiscountsRoute,
  } as any)
const AuthenticatedLocationsIdDiscountsDiscountIdEditRoute =
  AuthenticatedLocationsIdDiscountsDiscountIdEditRouteImport.update({
    id: '/$discountId/edit',
    path: '/$discountId/edit',
    getParentRoute: () => AuthenticatedLocationsIdDiscountsRoute,
  } as any)
const AuthenticatedLocationsIdProfileEditFieldRoute =
  AuthenticatedLocationsIdProfileEditFieldRouteImport.update({
    id: '/edit/$field',
    path: '/edit/$field',
    getParentRoute: () => AuthenticatedLocationsIdProfileRoute,
  } as any)
const AuthenticatedLocationsIdStationsStationIdEditRoute =
  AuthenticatedLocationsIdStationsStationIdEditRouteImport.update({
    id: '/$stationId/edit',
    path: '/$stationId/edit',
    getParentRoute: () => AuthenticatedLocationsIdStationsRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute =
  AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthenticatedMenusMenuIdCategoriesCategoryIdRoute,
  } as any)
const AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute =
  AuthenticatedMenusMenuIdCategoriesCategoryIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedMenusMenuIdCategoriesCategoryIdRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute =
  AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRouteImport.update({
    id: '/create-sales-category',
    path: '/create-sales-category',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsItemIdRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute =
  AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRouteImport.update({
    id: '/create-tax-category',
    path: '/create-tax-category',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsItemIdRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsItemIdDeleteRoute =
  AuthenticatedMenusMenuIdItemsItemIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsItemIdRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute =
  AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRouteImport.update({
    id: '/create-sales-category',
    path: '/create-sales-category',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsNewRoute,
  } as any)
const AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute =
  AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRouteImport.update({
    id: '/create-tax-category',
    path: '/create-tax-category',
    getParentRoute: () => AuthenticatedMenusMenuIdItemsNewRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute =
  AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute,
  } as any)
const AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute =
  AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRouteImport.update({
    id: '/duplicate',
    path: '/duplicate',
    getParentRoute: () => AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute,
  } as any)
const AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute =
  AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRouteImport.update({
    id: '/create-category',
    path: '/create-category',
    getParentRoute: () => AuthenticatedSettingsSalesCategoriesIdDeleteRoute,
  } as any)
const AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute =
  AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRouteImport.update({
    id: '/create-category',
    path: '/create-category',
    getParentRoute: () => AuthenticatedSettingsTaxCategoriesIdDeleteRoute,
  } as any)
const AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute =
  AuthenticatedSettingsTerminalsReadersReaderIdDeleteRouteImport.update({
    id: '/readers/$readerId/delete',
    path: '/readers/$readerId/delete',
    getParentRoute: () => AuthenticatedSettingsTerminalsRoute,
  } as any)
const AuthenticatedSettingsTerminalsReadersReaderIdEditRoute =
  AuthenticatedSettingsTerminalsReadersReaderIdEditRouteImport.update({
    id: '/readers/$readerId/edit',
    path: '/readers/$readerId/edit',
    getParentRoute: () => AuthenticatedSettingsTerminalsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/create-organization': typeof CreateOrganizationRoute
  '/onboarding': typeof OnboardingRoute
  '/select-organization': typeof SelectOrganizationRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/balances': typeof AuthenticatedBalancesRoute
  '/disputes': typeof AuthenticatedDisputesRoute
  '/documents': typeof AuthenticatedDocumentsRoute
  '/employees': typeof AuthenticatedEmployeesRouteWithChildren
  '/payments': typeof AuthenticatedPaymentsRouteWithChildren
  '/payouts': typeof AuthenticatedPayoutsRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/employees/$id': typeof AuthenticatedEmployeesIdRouteWithChildren
  '/employees/manage-roles': typeof AuthenticatedEmployeesManageRolesRoute
  '/employees/new': typeof AuthenticatedEmployeesNewRouteWithChildren
  '/employees/shifts': typeof AuthenticatedEmployeesShiftsRouteWithChildren
  '/locations/$id': typeof AuthenticatedLocationsIdRouteWithChildren
  '/locations/new': typeof AuthenticatedLocationsNewRoute
  '/menus/$menuId': typeof AuthenticatedMenusMenuIdRouteWithChildren
  '/menus/empty': typeof AuthenticatedMenusEmptyRoute
  '/menus/new': typeof AuthenticatedMenusNewRoute
  '/payments/$paymentId': typeof AuthenticatedPaymentsPaymentIdRoute
  '/reports/cash-operations': typeof AuthenticatedReportsCashOperationsRoute
  '/reports/detailed-order-type-report': typeof AuthenticatedReportsDetailedOrderTypeReportRoute
  '/reports/employee-earnings-summary': typeof AuthenticatedReportsEmployeeEarningsSummaryRoute
  '/reports/employee-performance': typeof AuthenticatedReportsEmployeePerformanceRoute
  '/reports/employee-sales-summary': typeof AuthenticatedReportsEmployeeSalesSummaryRoute
  '/reports/employee-tip-report': typeof AuthenticatedReportsEmployeeTipReportRoute
  '/reports/labor-summary': typeof AuthenticatedReportsLaborSummaryRoute
  '/reports/menu-performance': typeof AuthenticatedReportsMenuPerformanceRoute
  '/reports/sales-by-staff-summary': typeof AuthenticatedReportsSalesByStaffSummaryRoute
  '/reports/tax-collected-report': typeof AuthenticatedReportsTaxCollectedReportRoute
  '/reports/transaction-analysis': typeof AuthenticatedReportsTransactionAnalysisRoute
  '/settings/account-management': typeof AuthenticatedSettingsAccountManagementRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/business-information': typeof AuthenticatedSettingsBusinessInformationRouteWithChildren
  '/settings/menus': typeof AuthenticatedSettingsMenusRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/payment-account': typeof AuthenticatedSettingsPaymentAccountRoute
  '/settings/sales-categories': typeof AuthenticatedSettingsSalesCategoriesRouteWithChildren
  '/settings/tax-categories': typeof AuthenticatedSettingsTaxCategoriesRouteWithChildren
  '/settings/tax-rates': typeof AuthenticatedSettingsTaxRatesRoute
  '/settings/terminals': typeof AuthenticatedSettingsTerminalsRouteWithChildren
  '/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/locations/': typeof AuthenticatedLocationsIndexRoute
  '/menus/': typeof AuthenticatedMenusIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/employees/$id/toggle-status': typeof AuthenticatedEmployeesIdToggleStatusRoute
  '/employees/new/create-role': typeof AuthenticatedEmployeesNewCreateRoleRoute
  '/employees/shifts/new': typeof AuthenticatedEmployeesShiftsNewRoute
  '/locations/$id/devices': typeof AuthenticatedLocationsIdDevicesRouteWithChildren
  '/locations/$id/discounts': typeof AuthenticatedLocationsIdDiscountsRouteWithChildren
  '/locations/$id/edit': typeof AuthenticatedLocationsIdEditRoute
  '/locations/$id/end-of-day': typeof AuthenticatedLocationsIdEndOfDayRouteWithChildren
  '/locations/$id/kds-devices': typeof AuthenticatedLocationsIdKdsDevicesRoute
  '/locations/$id/online-ordering': typeof AuthenticatedLocationsIdOnlineOrderingRoute
  '/locations/$id/profile': typeof AuthenticatedLocationsIdProfileRouteWithChildren
  '/locations/$id/receipts': typeof AuthenticatedLocationsIdReceiptsRouteWithChildren
  '/locations/$id/stations': typeof AuthenticatedLocationsIdStationsRouteWithChildren
  '/locations/$id/tips': typeof AuthenticatedLocationsIdTipsRoute
  '/locations/$id/voids-and-refunds': typeof AuthenticatedLocationsIdVoidsAndRefundsRoute
  '/menus/$menuId/categories': typeof AuthenticatedMenusMenuIdCategoriesRouteWithChildren
  '/menus/$menuId/delete': typeof AuthenticatedMenusMenuIdDeleteRoute
  '/menus/$menuId/edit': typeof AuthenticatedMenusMenuIdEditRoute
  '/menus/$menuId/items': typeof AuthenticatedMenusMenuIdItemsRouteWithChildren
  '/menus/$menuId/modifiers': typeof AuthenticatedMenusMenuIdModifiersRouteWithChildren
  '/settings/account/$': typeof AuthenticatedSettingsAccountSplatRoute
  '/settings/sales-categories/new': typeof AuthenticatedSettingsSalesCategoriesNewRoute
  '/settings/tax-categories/new': typeof AuthenticatedSettingsTaxCategoriesNewRoute
  '/menus/$menuId/': typeof AuthenticatedMenusMenuIdIndexRoute
  '/employees/$id/edit/$field': typeof AuthenticatedEmployeesIdEditFieldRoute
  '/employees/shifts/$shiftId/delete': typeof AuthenticatedEmployeesShiftsShiftIdDeleteRoute
  '/employees/shifts/$shiftId/edit': typeof AuthenticatedEmployeesShiftsShiftIdEditRoute
  '/locations/$id/devices/$deviceId': typeof AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren
  '/locations/$id/discounts/new': typeof AuthenticatedLocationsIdDiscountsNewRoute
  '/locations/$id/discounts/settings': typeof AuthenticatedLocationsIdDiscountsSettingsRoute
  '/locations/$id/end-of-day/business-report': typeof AuthenticatedLocationsIdEndOfDayBusinessReportRoute
  '/locations/$id/end-of-day/employee-report': typeof AuthenticatedLocationsIdEndOfDayEmployeeReportRoute
  '/locations/$id/receipts/customer-bill': typeof AuthenticatedLocationsIdReceiptsCustomerBillRoute
  '/locations/$id/receipts/customer-receipt': typeof AuthenticatedLocationsIdReceiptsCustomerReceiptRoute
  '/locations/$id/receipts/kitchen-ticket': typeof AuthenticatedLocationsIdReceiptsKitchenTicketRoute
  '/locations/$id/stations/new': typeof AuthenticatedLocationsIdStationsNewRoute
  '/menus/$menuId/categories/$categoryId': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren
  '/menus/$menuId/categories/new': typeof AuthenticatedMenusMenuIdCategoriesNewRoute
  '/menus/$menuId/items/$itemId': typeof AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren
  '/menus/$menuId/items/new': typeof AuthenticatedMenusMenuIdItemsNewRouteWithChildren
  '/menus/$menuId/modifiers/$modifierGroupId': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren
  '/menus/$menuId/modifiers/new': typeof AuthenticatedMenusMenuIdModifiersNewRoute
  '/settings/business-information/edit/$type': typeof AuthenticatedSettingsBusinessInformationEditTypeRoute
  '/settings/sales-categories/$categoryId/edit': typeof AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute
  '/settings/sales-categories/$id/delete': typeof AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren
  '/settings/tax-categories/$categoryId/edit': typeof AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute
  '/settings/tax-categories/$id/delete': typeof AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren
  '/settings/terminals/order/$locationId': typeof AuthenticatedSettingsTerminalsOrderLocationIdRoute
  '/settings/terminals/register/$locationId': typeof AuthenticatedSettingsTerminalsRegisterLocationIdRoute
  '/settings/terminals/setup/$locationId': typeof AuthenticatedSettingsTerminalsSetupLocationIdRoute
  '/menus/$menuId/categories/': typeof AuthenticatedMenusMenuIdCategoriesIndexRoute
  '/menus/$menuId/items/': typeof AuthenticatedMenusMenuIdItemsIndexRoute
  '/menus/$menuId/modifiers/': typeof AuthenticatedMenusMenuIdModifiersIndexRoute
  '/locations/$id/devices/$deviceId/add-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute
  '/locations/$id/devices/$deviceId/delete': typeof AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute
  '/locations/$id/devices/$deviceId/remove-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute
  '/locations/$id/discounts/$discountId/delete': typeof AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute
  '/locations/$id/discounts/$discountId/edit': typeof AuthenticatedLocationsIdDiscountsDiscountIdEditRoute
  '/locations/$id/profile/edit/$field': typeof AuthenticatedLocationsIdProfileEditFieldRoute
  '/locations/$id/stations/$stationId/edit': typeof AuthenticatedLocationsIdStationsStationIdEditRoute
  '/menus/$menuId/categories/$categoryId/delete': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute
  '/menus/$menuId/categories/$categoryId/edit': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute
  '/menus/$menuId/items/$itemId/create-sales-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute
  '/menus/$menuId/items/$itemId/create-tax-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute
  '/menus/$menuId/items/$itemId/delete': typeof AuthenticatedMenusMenuIdItemsItemIdDeleteRoute
  '/menus/$menuId/items/new/create-sales-category': typeof AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute
  '/menus/$menuId/items/new/create-tax-category': typeof AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute
  '/menus/$menuId/modifiers/$modifierGroupId/delete': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute
  '/menus/$menuId/modifiers/$modifierGroupId/duplicate': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute
  '/settings/sales-categories/$id/delete/create-category': typeof AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute
  '/settings/tax-categories/$id/delete/create-category': typeof AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute
  '/settings/terminals/readers/$readerId/delete': typeof AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute
  '/settings/terminals/readers/$readerId/edit': typeof AuthenticatedSettingsTerminalsReadersReaderIdEditRoute
}
export interface FileRoutesByTo {
  '/accept-invite': typeof AcceptInviteRoute
  '/create-organization': typeof CreateOrganizationRoute
  '/onboarding': typeof OnboardingRoute
  '/select-organization': typeof SelectOrganizationRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/balances': typeof AuthenticatedBalancesRoute
  '/disputes': typeof AuthenticatedDisputesRoute
  '/documents': typeof AuthenticatedDocumentsRoute
  '/payments': typeof AuthenticatedPaymentsRouteWithChildren
  '/payouts': typeof AuthenticatedPayoutsRoute
  '/': typeof AuthenticatedIndexRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdRouteWithChildren
  '/employees/manage-roles': typeof AuthenticatedEmployeesManageRolesRoute
  '/employees/new': typeof AuthenticatedEmployeesNewRouteWithChildren
  '/employees/shifts': typeof AuthenticatedEmployeesShiftsRouteWithChildren
  '/locations/$id': typeof AuthenticatedLocationsIdRouteWithChildren
  '/locations/new': typeof AuthenticatedLocationsNewRoute
  '/menus/empty': typeof AuthenticatedMenusEmptyRoute
  '/menus/new': typeof AuthenticatedMenusNewRoute
  '/payments/$paymentId': typeof AuthenticatedPaymentsPaymentIdRoute
  '/reports/cash-operations': typeof AuthenticatedReportsCashOperationsRoute
  '/reports/detailed-order-type-report': typeof AuthenticatedReportsDetailedOrderTypeReportRoute
  '/reports/employee-earnings-summary': typeof AuthenticatedReportsEmployeeEarningsSummaryRoute
  '/reports/employee-performance': typeof AuthenticatedReportsEmployeePerformanceRoute
  '/reports/employee-sales-summary': typeof AuthenticatedReportsEmployeeSalesSummaryRoute
  '/reports/employee-tip-report': typeof AuthenticatedReportsEmployeeTipReportRoute
  '/reports/labor-summary': typeof AuthenticatedReportsLaborSummaryRoute
  '/reports/menu-performance': typeof AuthenticatedReportsMenuPerformanceRoute
  '/reports/sales-by-staff-summary': typeof AuthenticatedReportsSalesByStaffSummaryRoute
  '/reports/tax-collected-report': typeof AuthenticatedReportsTaxCollectedReportRoute
  '/reports/transaction-analysis': typeof AuthenticatedReportsTransactionAnalysisRoute
  '/settings/account-management': typeof AuthenticatedSettingsAccountManagementRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/business-information': typeof AuthenticatedSettingsBusinessInformationRouteWithChildren
  '/settings/menus': typeof AuthenticatedSettingsMenusRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/payment-account': typeof AuthenticatedSettingsPaymentAccountRoute
  '/settings/sales-categories': typeof AuthenticatedSettingsSalesCategoriesRouteWithChildren
  '/settings/tax-categories': typeof AuthenticatedSettingsTaxCategoriesRouteWithChildren
  '/settings/tax-rates': typeof AuthenticatedSettingsTaxRatesRoute
  '/settings/terminals': typeof AuthenticatedSettingsTerminalsRouteWithChildren
  '/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/locations': typeof AuthenticatedLocationsIndexRoute
  '/menus': typeof AuthenticatedMenusIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/employees/$id/toggle-status': typeof AuthenticatedEmployeesIdToggleStatusRoute
  '/employees/new/create-role': typeof AuthenticatedEmployeesNewCreateRoleRoute
  '/employees/shifts/new': typeof AuthenticatedEmployeesShiftsNewRoute
  '/locations/$id/devices': typeof AuthenticatedLocationsIdDevicesRouteWithChildren
  '/locations/$id/discounts': typeof AuthenticatedLocationsIdDiscountsRouteWithChildren
  '/locations/$id/edit': typeof AuthenticatedLocationsIdEditRoute
  '/locations/$id/end-of-day': typeof AuthenticatedLocationsIdEndOfDayRouteWithChildren
  '/locations/$id/kds-devices': typeof AuthenticatedLocationsIdKdsDevicesRoute
  '/locations/$id/online-ordering': typeof AuthenticatedLocationsIdOnlineOrderingRoute
  '/locations/$id/profile': typeof AuthenticatedLocationsIdProfileRouteWithChildren
  '/locations/$id/receipts': typeof AuthenticatedLocationsIdReceiptsRouteWithChildren
  '/locations/$id/stations': typeof AuthenticatedLocationsIdStationsRouteWithChildren
  '/locations/$id/tips': typeof AuthenticatedLocationsIdTipsRoute
  '/locations/$id/voids-and-refunds': typeof AuthenticatedLocationsIdVoidsAndRefundsRoute
  '/menus/$menuId/delete': typeof AuthenticatedMenusMenuIdDeleteRoute
  '/menus/$menuId/edit': typeof AuthenticatedMenusMenuIdEditRoute
  '/settings/account/$': typeof AuthenticatedSettingsAccountSplatRoute
  '/settings/sales-categories/new': typeof AuthenticatedSettingsSalesCategoriesNewRoute
  '/settings/tax-categories/new': typeof AuthenticatedSettingsTaxCategoriesNewRoute
  '/menus/$menuId': typeof AuthenticatedMenusMenuIdIndexRoute
  '/employees/$id/edit/$field': typeof AuthenticatedEmployeesIdEditFieldRoute
  '/employees/shifts/$shiftId/delete': typeof AuthenticatedEmployeesShiftsShiftIdDeleteRoute
  '/employees/shifts/$shiftId/edit': typeof AuthenticatedEmployeesShiftsShiftIdEditRoute
  '/locations/$id/devices/$deviceId': typeof AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren
  '/locations/$id/discounts/new': typeof AuthenticatedLocationsIdDiscountsNewRoute
  '/locations/$id/discounts/settings': typeof AuthenticatedLocationsIdDiscountsSettingsRoute
  '/locations/$id/end-of-day/business-report': typeof AuthenticatedLocationsIdEndOfDayBusinessReportRoute
  '/locations/$id/end-of-day/employee-report': typeof AuthenticatedLocationsIdEndOfDayEmployeeReportRoute
  '/locations/$id/receipts/customer-bill': typeof AuthenticatedLocationsIdReceiptsCustomerBillRoute
  '/locations/$id/receipts/customer-receipt': typeof AuthenticatedLocationsIdReceiptsCustomerReceiptRoute
  '/locations/$id/receipts/kitchen-ticket': typeof AuthenticatedLocationsIdReceiptsKitchenTicketRoute
  '/locations/$id/stations/new': typeof AuthenticatedLocationsIdStationsNewRoute
  '/menus/$menuId/categories/$categoryId': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren
  '/menus/$menuId/categories/new': typeof AuthenticatedMenusMenuIdCategoriesNewRoute
  '/menus/$menuId/items/$itemId': typeof AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren
  '/menus/$menuId/items/new': typeof AuthenticatedMenusMenuIdItemsNewRouteWithChildren
  '/menus/$menuId/modifiers/$modifierGroupId': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren
  '/menus/$menuId/modifiers/new': typeof AuthenticatedMenusMenuIdModifiersNewRoute
  '/settings/business-information/edit/$type': typeof AuthenticatedSettingsBusinessInformationEditTypeRoute
  '/settings/sales-categories/$categoryId/edit': typeof AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute
  '/settings/sales-categories/$id/delete': typeof AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren
  '/settings/tax-categories/$categoryId/edit': typeof AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute
  '/settings/tax-categories/$id/delete': typeof AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren
  '/settings/terminals/order/$locationId': typeof AuthenticatedSettingsTerminalsOrderLocationIdRoute
  '/settings/terminals/register/$locationId': typeof AuthenticatedSettingsTerminalsRegisterLocationIdRoute
  '/settings/terminals/setup/$locationId': typeof AuthenticatedSettingsTerminalsSetupLocationIdRoute
  '/menus/$menuId/categories': typeof AuthenticatedMenusMenuIdCategoriesIndexRoute
  '/menus/$menuId/items': typeof AuthenticatedMenusMenuIdItemsIndexRoute
  '/menus/$menuId/modifiers': typeof AuthenticatedMenusMenuIdModifiersIndexRoute
  '/locations/$id/devices/$deviceId/add-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute
  '/locations/$id/devices/$deviceId/delete': typeof AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute
  '/locations/$id/devices/$deviceId/remove-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute
  '/locations/$id/discounts/$discountId/delete': typeof AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute
  '/locations/$id/discounts/$discountId/edit': typeof AuthenticatedLocationsIdDiscountsDiscountIdEditRoute
  '/locations/$id/profile/edit/$field': typeof AuthenticatedLocationsIdProfileEditFieldRoute
  '/locations/$id/stations/$stationId/edit': typeof AuthenticatedLocationsIdStationsStationIdEditRoute
  '/menus/$menuId/categories/$categoryId/delete': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute
  '/menus/$menuId/categories/$categoryId/edit': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute
  '/menus/$menuId/items/$itemId/create-sales-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute
  '/menus/$menuId/items/$itemId/create-tax-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute
  '/menus/$menuId/items/$itemId/delete': typeof AuthenticatedMenusMenuIdItemsItemIdDeleteRoute
  '/menus/$menuId/items/new/create-sales-category': typeof AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute
  '/menus/$menuId/items/new/create-tax-category': typeof AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute
  '/menus/$menuId/modifiers/$modifierGroupId/delete': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute
  '/menus/$menuId/modifiers/$modifierGroupId/duplicate': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute
  '/settings/sales-categories/$id/delete/create-category': typeof AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute
  '/settings/tax-categories/$id/delete/create-category': typeof AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute
  '/settings/terminals/readers/$readerId/delete': typeof AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute
  '/settings/terminals/readers/$readerId/edit': typeof AuthenticatedSettingsTerminalsReadersReaderIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/create-organization': typeof CreateOrganizationRoute
  '/onboarding': typeof OnboardingRoute
  '/select-organization': typeof SelectOrganizationRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/balances': typeof AuthenticatedBalancesRoute
  '/_authenticated/disputes': typeof AuthenticatedDisputesRoute
  '/_authenticated/documents': typeof AuthenticatedDocumentsRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRouteWithChildren
  '/_authenticated/payments': typeof AuthenticatedPaymentsRouteWithChildren
  '/_authenticated/payouts': typeof AuthenticatedPayoutsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/employees/$id': typeof AuthenticatedEmployeesIdRouteWithChildren
  '/_authenticated/employees/manage-roles': typeof AuthenticatedEmployeesManageRolesRoute
  '/_authenticated/employees/new': typeof AuthenticatedEmployeesNewRouteWithChildren
  '/_authenticated/employees/shifts': typeof AuthenticatedEmployeesShiftsRouteWithChildren
  '/_authenticated/locations/$id': typeof AuthenticatedLocationsIdRouteWithChildren
  '/_authenticated/locations/new': typeof AuthenticatedLocationsNewRoute
  '/_authenticated/menus/$menuId': typeof AuthenticatedMenusMenuIdRouteWithChildren
  '/_authenticated/menus/empty': typeof AuthenticatedMenusEmptyRoute
  '/_authenticated/menus/new': typeof AuthenticatedMenusNewRoute
  '/_authenticated/payments/$paymentId': typeof AuthenticatedPaymentsPaymentIdRoute
  '/_authenticated/reports/cash-operations': typeof AuthenticatedReportsCashOperationsRoute
  '/_authenticated/reports/detailed-order-type-report': typeof AuthenticatedReportsDetailedOrderTypeReportRoute
  '/_authenticated/reports/employee-earnings-summary': typeof AuthenticatedReportsEmployeeEarningsSummaryRoute
  '/_authenticated/reports/employee-performance': typeof AuthenticatedReportsEmployeePerformanceRoute
  '/_authenticated/reports/employee-sales-summary': typeof AuthenticatedReportsEmployeeSalesSummaryRoute
  '/_authenticated/reports/employee-tip-report': typeof AuthenticatedReportsEmployeeTipReportRoute
  '/_authenticated/reports/labor-summary': typeof AuthenticatedReportsLaborSummaryRoute
  '/_authenticated/reports/menu-performance': typeof AuthenticatedReportsMenuPerformanceRoute
  '/_authenticated/reports/sales-by-staff-summary': typeof AuthenticatedReportsSalesByStaffSummaryRoute
  '/_authenticated/reports/tax-collected-report': typeof AuthenticatedReportsTaxCollectedReportRoute
  '/_authenticated/reports/transaction-analysis': typeof AuthenticatedReportsTransactionAnalysisRoute
  '/_authenticated/settings/account-management': typeof AuthenticatedSettingsAccountManagementRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/business-information': typeof AuthenticatedSettingsBusinessInformationRouteWithChildren
  '/_authenticated/settings/menus': typeof AuthenticatedSettingsMenusRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/_authenticated/settings/payment-account': typeof AuthenticatedSettingsPaymentAccountRoute
  '/_authenticated/settings/sales-categories': typeof AuthenticatedSettingsSalesCategoriesRouteWithChildren
  '/_authenticated/settings/tax-categories': typeof AuthenticatedSettingsTaxCategoriesRouteWithChildren
  '/_authenticated/settings/tax-rates': typeof AuthenticatedSettingsTaxRatesRoute
  '/_authenticated/settings/terminals': typeof AuthenticatedSettingsTerminalsRouteWithChildren
  '/_authenticated/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/_authenticated/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/_authenticated/locations/': typeof AuthenticatedLocationsIndexRoute
  '/_authenticated/menus/': typeof AuthenticatedMenusIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/employees/$id/toggle-status': typeof AuthenticatedEmployeesIdToggleStatusRoute
  '/_authenticated/employees/new/create-role': typeof AuthenticatedEmployeesNewCreateRoleRoute
  '/_authenticated/employees/shifts/new': typeof AuthenticatedEmployeesShiftsNewRoute
  '/_authenticated/locations/$id/devices': typeof AuthenticatedLocationsIdDevicesRouteWithChildren
  '/_authenticated/locations/$id/discounts': typeof AuthenticatedLocationsIdDiscountsRouteWithChildren
  '/_authenticated/locations/$id/edit': typeof AuthenticatedLocationsIdEditRoute
  '/_authenticated/locations/$id/end-of-day': typeof AuthenticatedLocationsIdEndOfDayRouteWithChildren
  '/_authenticated/locations/$id/kds-devices': typeof AuthenticatedLocationsIdKdsDevicesRoute
  '/_authenticated/locations/$id/online-ordering': typeof AuthenticatedLocationsIdOnlineOrderingRoute
  '/_authenticated/locations/$id/profile': typeof AuthenticatedLocationsIdProfileRouteWithChildren
  '/_authenticated/locations/$id/receipts': typeof AuthenticatedLocationsIdReceiptsRouteWithChildren
  '/_authenticated/locations/$id/stations': typeof AuthenticatedLocationsIdStationsRouteWithChildren
  '/_authenticated/locations/$id/tips': typeof AuthenticatedLocationsIdTipsRoute
  '/_authenticated/locations/$id/voids-and-refunds': typeof AuthenticatedLocationsIdVoidsAndRefundsRoute
  '/_authenticated/menus/$menuId/categories': typeof AuthenticatedMenusMenuIdCategoriesRouteWithChildren
  '/_authenticated/menus/$menuId/delete': typeof AuthenticatedMenusMenuIdDeleteRoute
  '/_authenticated/menus/$menuId/edit': typeof AuthenticatedMenusMenuIdEditRoute
  '/_authenticated/menus/$menuId/items': typeof AuthenticatedMenusMenuIdItemsRouteWithChildren
  '/_authenticated/menus/$menuId/modifiers': typeof AuthenticatedMenusMenuIdModifiersRouteWithChildren
  '/_authenticated/settings/account/$': typeof AuthenticatedSettingsAccountSplatRoute
  '/_authenticated/settings/sales-categories/new': typeof AuthenticatedSettingsSalesCategoriesNewRoute
  '/_authenticated/settings/tax-categories/new': typeof AuthenticatedSettingsTaxCategoriesNewRoute
  '/_authenticated/menus/$menuId/': typeof AuthenticatedMenusMenuIdIndexRoute
  '/_authenticated/employees/$id/edit/$field': typeof AuthenticatedEmployeesIdEditFieldRoute
  '/_authenticated/employees/shifts/$shiftId/delete': typeof AuthenticatedEmployeesShiftsShiftIdDeleteRoute
  '/_authenticated/employees/shifts/$shiftId/edit': typeof AuthenticatedEmployeesShiftsShiftIdEditRoute
  '/_authenticated/locations/$id/devices/$deviceId': typeof AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren
  '/_authenticated/locations/$id/discounts/new': typeof AuthenticatedLocationsIdDiscountsNewRoute
  '/_authenticated/locations/$id/discounts/settings': typeof AuthenticatedLocationsIdDiscountsSettingsRoute
  '/_authenticated/locations/$id/end-of-day/business-report': typeof AuthenticatedLocationsIdEndOfDayBusinessReportRoute
  '/_authenticated/locations/$id/end-of-day/employee-report': typeof AuthenticatedLocationsIdEndOfDayEmployeeReportRoute
  '/_authenticated/locations/$id/receipts/customer-bill': typeof AuthenticatedLocationsIdReceiptsCustomerBillRoute
  '/_authenticated/locations/$id/receipts/customer-receipt': typeof AuthenticatedLocationsIdReceiptsCustomerReceiptRoute
  '/_authenticated/locations/$id/receipts/kitchen-ticket': typeof AuthenticatedLocationsIdReceiptsKitchenTicketRoute
  '/_authenticated/locations/$id/stations/new': typeof AuthenticatedLocationsIdStationsNewRoute
  '/_authenticated/menus/$menuId/categories/$categoryId': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren
  '/_authenticated/menus/$menuId/categories/new': typeof AuthenticatedMenusMenuIdCategoriesNewRoute
  '/_authenticated/menus/$menuId/items/$itemId': typeof AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren
  '/_authenticated/menus/$menuId/items/new': typeof AuthenticatedMenusMenuIdItemsNewRouteWithChildren
  '/_authenticated/menus/$menuId/modifiers/$modifierGroupId': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren
  '/_authenticated/menus/$menuId/modifiers/new': typeof AuthenticatedMenusMenuIdModifiersNewRoute
  '/_authenticated/settings/business-information/edit/$type': typeof AuthenticatedSettingsBusinessInformationEditTypeRoute
  '/_authenticated/settings/sales-categories/$categoryId/edit': typeof AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute
  '/_authenticated/settings/sales-categories/$id/delete': typeof AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren
  '/_authenticated/settings/tax-categories/$categoryId/edit': typeof AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute
  '/_authenticated/settings/tax-categories/$id/delete': typeof AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren
  '/_authenticated/settings/terminals/order/$locationId': typeof AuthenticatedSettingsTerminalsOrderLocationIdRoute
  '/_authenticated/settings/terminals/register/$locationId': typeof AuthenticatedSettingsTerminalsRegisterLocationIdRoute
  '/_authenticated/settings/terminals/setup/$locationId': typeof AuthenticatedSettingsTerminalsSetupLocationIdRoute
  '/_authenticated/menus/$menuId/categories/': typeof AuthenticatedMenusMenuIdCategoriesIndexRoute
  '/_authenticated/menus/$menuId/items/': typeof AuthenticatedMenusMenuIdItemsIndexRoute
  '/_authenticated/menus/$menuId/modifiers/': typeof AuthenticatedMenusMenuIdModifiersIndexRoute
  '/_authenticated/locations/$id/devices/$deviceId/add-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute
  '/_authenticated/locations/$id/devices/$deviceId/delete': typeof AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute
  '/_authenticated/locations/$id/devices/$deviceId/remove-terminal': typeof AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute
  '/_authenticated/locations/$id/discounts/$discountId/delete': typeof AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute
  '/_authenticated/locations/$id/discounts/$discountId/edit': typeof AuthenticatedLocationsIdDiscountsDiscountIdEditRoute
  '/_authenticated/locations/$id/profile/edit/$field': typeof AuthenticatedLocationsIdProfileEditFieldRoute
  '/_authenticated/locations/$id/stations/$stationId/edit': typeof AuthenticatedLocationsIdStationsStationIdEditRoute
  '/_authenticated/menus/$menuId/categories/$categoryId/delete': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute
  '/_authenticated/menus/$menuId/categories/$categoryId/edit': typeof AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute
  '/_authenticated/menus/$menuId/items/$itemId/create-sales-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute
  '/_authenticated/menus/$menuId/items/$itemId/create-tax-category': typeof AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute
  '/_authenticated/menus/$menuId/items/$itemId/delete': typeof AuthenticatedMenusMenuIdItemsItemIdDeleteRoute
  '/_authenticated/menus/$menuId/items/new/create-sales-category': typeof AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute
  '/_authenticated/menus/$menuId/items/new/create-tax-category': typeof AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute
  '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/delete': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute
  '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/duplicate': typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute
  '/_authenticated/settings/sales-categories/$id/delete/create-category': typeof AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute
  '/_authenticated/settings/tax-categories/$id/delete/create-category': typeof AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute
  '/_authenticated/settings/terminals/readers/$readerId/delete': typeof AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute
  '/_authenticated/settings/terminals/readers/$readerId/edit': typeof AuthenticatedSettingsTerminalsReadersReaderIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/create-organization'
    | '/onboarding'
    | '/select-organization'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/analytics'
    | '/balances'
    | '/disputes'
    | '/documents'
    | '/employees'
    | '/payments'
    | '/payouts'
    | '/reports'
    | '/settings'
    | '/employees/$id'
    | '/employees/manage-roles'
    | '/employees/new'
    | '/employees/shifts'
    | '/locations/$id'
    | '/locations/new'
    | '/menus/$menuId'
    | '/menus/empty'
    | '/menus/new'
    | '/payments/$paymentId'
    | '/reports/cash-operations'
    | '/reports/detailed-order-type-report'
    | '/reports/employee-earnings-summary'
    | '/reports/employee-performance'
    | '/reports/employee-sales-summary'
    | '/reports/employee-tip-report'
    | '/reports/labor-summary'
    | '/reports/menu-performance'
    | '/reports/sales-by-staff-summary'
    | '/reports/tax-collected-report'
    | '/reports/transaction-analysis'
    | '/settings/account-management'
    | '/settings/billing'
    | '/settings/business-information'
    | '/settings/menus'
    | '/settings/organization'
    | '/settings/payment-account'
    | '/settings/sales-categories'
    | '/settings/tax-categories'
    | '/settings/tax-rates'
    | '/settings/terminals'
    | '/settings/usage'
    | '/employees/'
    | '/locations/'
    | '/menus/'
    | '/reports/'
    | '/settings/'
    | '/employees/$id/toggle-status'
    | '/employees/new/create-role'
    | '/employees/shifts/new'
    | '/locations/$id/devices'
    | '/locations/$id/discounts'
    | '/locations/$id/edit'
    | '/locations/$id/end-of-day'
    | '/locations/$id/kds-devices'
    | '/locations/$id/online-ordering'
    | '/locations/$id/profile'
    | '/locations/$id/receipts'
    | '/locations/$id/stations'
    | '/locations/$id/tips'
    | '/locations/$id/voids-and-refunds'
    | '/menus/$menuId/categories'
    | '/menus/$menuId/delete'
    | '/menus/$menuId/edit'
    | '/menus/$menuId/items'
    | '/menus/$menuId/modifiers'
    | '/settings/account/$'
    | '/settings/sales-categories/new'
    | '/settings/tax-categories/new'
    | '/menus/$menuId/'
    | '/employees/$id/edit/$field'
    | '/employees/shifts/$shiftId/delete'
    | '/employees/shifts/$shiftId/edit'
    | '/locations/$id/devices/$deviceId'
    | '/locations/$id/discounts/new'
    | '/locations/$id/discounts/settings'
    | '/locations/$id/end-of-day/business-report'
    | '/locations/$id/end-of-day/employee-report'
    | '/locations/$id/receipts/customer-bill'
    | '/locations/$id/receipts/customer-receipt'
    | '/locations/$id/receipts/kitchen-ticket'
    | '/locations/$id/stations/new'
    | '/menus/$menuId/categories/$categoryId'
    | '/menus/$menuId/categories/new'
    | '/menus/$menuId/items/$itemId'
    | '/menus/$menuId/items/new'
    | '/menus/$menuId/modifiers/$modifierGroupId'
    | '/menus/$menuId/modifiers/new'
    | '/settings/business-information/edit/$type'
    | '/settings/sales-categories/$categoryId/edit'
    | '/settings/sales-categories/$id/delete'
    | '/settings/tax-categories/$categoryId/edit'
    | '/settings/tax-categories/$id/delete'
    | '/settings/terminals/order/$locationId'
    | '/settings/terminals/register/$locationId'
    | '/settings/terminals/setup/$locationId'
    | '/menus/$menuId/categories/'
    | '/menus/$menuId/items/'
    | '/menus/$menuId/modifiers/'
    | '/locations/$id/devices/$deviceId/add-terminal'
    | '/locations/$id/devices/$deviceId/delete'
    | '/locations/$id/devices/$deviceId/remove-terminal'
    | '/locations/$id/discounts/$discountId/delete'
    | '/locations/$id/discounts/$discountId/edit'
    | '/locations/$id/profile/edit/$field'
    | '/locations/$id/stations/$stationId/edit'
    | '/menus/$menuId/categories/$categoryId/delete'
    | '/menus/$menuId/categories/$categoryId/edit'
    | '/menus/$menuId/items/$itemId/create-sales-category'
    | '/menus/$menuId/items/$itemId/create-tax-category'
    | '/menus/$menuId/items/$itemId/delete'
    | '/menus/$menuId/items/new/create-sales-category'
    | '/menus/$menuId/items/new/create-tax-category'
    | '/menus/$menuId/modifiers/$modifierGroupId/delete'
    | '/menus/$menuId/modifiers/$modifierGroupId/duplicate'
    | '/settings/sales-categories/$id/delete/create-category'
    | '/settings/tax-categories/$id/delete/create-category'
    | '/settings/terminals/readers/$readerId/delete'
    | '/settings/terminals/readers/$readerId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invite'
    | '/create-organization'
    | '/onboarding'
    | '/select-organization'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/analytics'
    | '/balances'
    | '/disputes'
    | '/documents'
    | '/payments'
    | '/payouts'
    | '/'
    | '/employees/$id'
    | '/employees/manage-roles'
    | '/employees/new'
    | '/employees/shifts'
    | '/locations/$id'
    | '/locations/new'
    | '/menus/empty'
    | '/menus/new'
    | '/payments/$paymentId'
    | '/reports/cash-operations'
    | '/reports/detailed-order-type-report'
    | '/reports/employee-earnings-summary'
    | '/reports/employee-performance'
    | '/reports/employee-sales-summary'
    | '/reports/employee-tip-report'
    | '/reports/labor-summary'
    | '/reports/menu-performance'
    | '/reports/sales-by-staff-summary'
    | '/reports/tax-collected-report'
    | '/reports/transaction-analysis'
    | '/settings/account-management'
    | '/settings/billing'
    | '/settings/business-information'
    | '/settings/menus'
    | '/settings/organization'
    | '/settings/payment-account'
    | '/settings/sales-categories'
    | '/settings/tax-categories'
    | '/settings/tax-rates'
    | '/settings/terminals'
    | '/settings/usage'
    | '/employees'
    | '/locations'
    | '/menus'
    | '/reports'
    | '/settings'
    | '/employees/$id/toggle-status'
    | '/employees/new/create-role'
    | '/employees/shifts/new'
    | '/locations/$id/devices'
    | '/locations/$id/discounts'
    | '/locations/$id/edit'
    | '/locations/$id/end-of-day'
    | '/locations/$id/kds-devices'
    | '/locations/$id/online-ordering'
    | '/locations/$id/profile'
    | '/locations/$id/receipts'
    | '/locations/$id/stations'
    | '/locations/$id/tips'
    | '/locations/$id/voids-and-refunds'
    | '/menus/$menuId/delete'
    | '/menus/$menuId/edit'
    | '/settings/account/$'
    | '/settings/sales-categories/new'
    | '/settings/tax-categories/new'
    | '/menus/$menuId'
    | '/employees/$id/edit/$field'
    | '/employees/shifts/$shiftId/delete'
    | '/employees/shifts/$shiftId/edit'
    | '/locations/$id/devices/$deviceId'
    | '/locations/$id/discounts/new'
    | '/locations/$id/discounts/settings'
    | '/locations/$id/end-of-day/business-report'
    | '/locations/$id/end-of-day/employee-report'
    | '/locations/$id/receipts/customer-bill'
    | '/locations/$id/receipts/customer-receipt'
    | '/locations/$id/receipts/kitchen-ticket'
    | '/locations/$id/stations/new'
    | '/menus/$menuId/categories/$categoryId'
    | '/menus/$menuId/categories/new'
    | '/menus/$menuId/items/$itemId'
    | '/menus/$menuId/items/new'
    | '/menus/$menuId/modifiers/$modifierGroupId'
    | '/menus/$menuId/modifiers/new'
    | '/settings/business-information/edit/$type'
    | '/settings/sales-categories/$categoryId/edit'
    | '/settings/sales-categories/$id/delete'
    | '/settings/tax-categories/$categoryId/edit'
    | '/settings/tax-categories/$id/delete'
    | '/settings/terminals/order/$locationId'
    | '/settings/terminals/register/$locationId'
    | '/settings/terminals/setup/$locationId'
    | '/menus/$menuId/categories'
    | '/menus/$menuId/items'
    | '/menus/$menuId/modifiers'
    | '/locations/$id/devices/$deviceId/add-terminal'
    | '/locations/$id/devices/$deviceId/delete'
    | '/locations/$id/devices/$deviceId/remove-terminal'
    | '/locations/$id/discounts/$discountId/delete'
    | '/locations/$id/discounts/$discountId/edit'
    | '/locations/$id/profile/edit/$field'
    | '/locations/$id/stations/$stationId/edit'
    | '/menus/$menuId/categories/$categoryId/delete'
    | '/menus/$menuId/categories/$categoryId/edit'
    | '/menus/$menuId/items/$itemId/create-sales-category'
    | '/menus/$menuId/items/$itemId/create-tax-category'
    | '/menus/$menuId/items/$itemId/delete'
    | '/menus/$menuId/items/new/create-sales-category'
    | '/menus/$menuId/items/new/create-tax-category'
    | '/menus/$menuId/modifiers/$modifierGroupId/delete'
    | '/menus/$menuId/modifiers/$modifierGroupId/duplicate'
    | '/settings/sales-categories/$id/delete/create-category'
    | '/settings/tax-categories/$id/delete/create-category'
    | '/settings/terminals/readers/$readerId/delete'
    | '/settings/terminals/readers/$readerId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/accept-invite'
    | '/create-organization'
    | '/onboarding'
    | '/select-organization'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/_authenticated/analytics'
    | '/_authenticated/balances'
    | '/_authenticated/disputes'
    | '/_authenticated/documents'
    | '/_authenticated/employees'
    | '/_authenticated/payments'
    | '/_authenticated/payouts'
    | '/_authenticated/reports'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/employees/$id'
    | '/_authenticated/employees/manage-roles'
    | '/_authenticated/employees/new'
    | '/_authenticated/employees/shifts'
    | '/_authenticated/locations/$id'
    | '/_authenticated/locations/new'
    | '/_authenticated/menus/$menuId'
    | '/_authenticated/menus/empty'
    | '/_authenticated/menus/new'
    | '/_authenticated/payments/$paymentId'
    | '/_authenticated/reports/cash-operations'
    | '/_authenticated/reports/detailed-order-type-report'
    | '/_authenticated/reports/employee-earnings-summary'
    | '/_authenticated/reports/employee-performance'
    | '/_authenticated/reports/employee-sales-summary'
    | '/_authenticated/reports/employee-tip-report'
    | '/_authenticated/reports/labor-summary'
    | '/_authenticated/reports/menu-performance'
    | '/_authenticated/reports/sales-by-staff-summary'
    | '/_authenticated/reports/tax-collected-report'
    | '/_authenticated/reports/transaction-analysis'
    | '/_authenticated/settings/account-management'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/business-information'
    | '/_authenticated/settings/menus'
    | '/_authenticated/settings/organization'
    | '/_authenticated/settings/payment-account'
    | '/_authenticated/settings/sales-categories'
    | '/_authenticated/settings/tax-categories'
    | '/_authenticated/settings/tax-rates'
    | '/_authenticated/settings/terminals'
    | '/_authenticated/settings/usage'
    | '/_authenticated/employees/'
    | '/_authenticated/locations/'
    | '/_authenticated/menus/'
    | '/_authenticated/reports/'
    | '/_authenticated/settings/'
    | '/_authenticated/employees/$id/toggle-status'
    | '/_authenticated/employees/new/create-role'
    | '/_authenticated/employees/shifts/new'
    | '/_authenticated/locations/$id/devices'
    | '/_authenticated/locations/$id/discounts'
    | '/_authenticated/locations/$id/edit'
    | '/_authenticated/locations/$id/end-of-day'
    | '/_authenticated/locations/$id/kds-devices'
    | '/_authenticated/locations/$id/online-ordering'
    | '/_authenticated/locations/$id/profile'
    | '/_authenticated/locations/$id/receipts'
    | '/_authenticated/locations/$id/stations'
    | '/_authenticated/locations/$id/tips'
    | '/_authenticated/locations/$id/voids-and-refunds'
    | '/_authenticated/menus/$menuId/categories'
    | '/_authenticated/menus/$menuId/delete'
    | '/_authenticated/menus/$menuId/edit'
    | '/_authenticated/menus/$menuId/items'
    | '/_authenticated/menus/$menuId/modifiers'
    | '/_authenticated/settings/account/$'
    | '/_authenticated/settings/sales-categories/new'
    | '/_authenticated/settings/tax-categories/new'
    | '/_authenticated/menus/$menuId/'
    | '/_authenticated/employees/$id/edit/$field'
    | '/_authenticated/employees/shifts/$shiftId/delete'
    | '/_authenticated/employees/shifts/$shiftId/edit'
    | '/_authenticated/locations/$id/devices/$deviceId'
    | '/_authenticated/locations/$id/discounts/new'
    | '/_authenticated/locations/$id/discounts/settings'
    | '/_authenticated/locations/$id/end-of-day/business-report'
    | '/_authenticated/locations/$id/end-of-day/employee-report'
    | '/_authenticated/locations/$id/receipts/customer-bill'
    | '/_authenticated/locations/$id/receipts/customer-receipt'
    | '/_authenticated/locations/$id/receipts/kitchen-ticket'
    | '/_authenticated/locations/$id/stations/new'
    | '/_authenticated/menus/$menuId/categories/$categoryId'
    | '/_authenticated/menus/$menuId/categories/new'
    | '/_authenticated/menus/$menuId/items/$itemId'
    | '/_authenticated/menus/$menuId/items/new'
    | '/_authenticated/menus/$menuId/modifiers/$modifierGroupId'
    | '/_authenticated/menus/$menuId/modifiers/new'
    | '/_authenticated/settings/business-information/edit/$type'
    | '/_authenticated/settings/sales-categories/$categoryId/edit'
    | '/_authenticated/settings/sales-categories/$id/delete'
    | '/_authenticated/settings/tax-categories/$categoryId/edit'
    | '/_authenticated/settings/tax-categories/$id/delete'
    | '/_authenticated/settings/terminals/order/$locationId'
    | '/_authenticated/settings/terminals/register/$locationId'
    | '/_authenticated/settings/terminals/setup/$locationId'
    | '/_authenticated/menus/$menuId/categories/'
    | '/_authenticated/menus/$menuId/items/'
    | '/_authenticated/menus/$menuId/modifiers/'
    | '/_authenticated/locations/$id/devices/$deviceId/add-terminal'
    | '/_authenticated/locations/$id/devices/$deviceId/delete'
    | '/_authenticated/locations/$id/devices/$deviceId/remove-terminal'
    | '/_authenticated/locations/$id/discounts/$discountId/delete'
    | '/_authenticated/locations/$id/discounts/$discountId/edit'
    | '/_authenticated/locations/$id/profile/edit/$field'
    | '/_authenticated/locations/$id/stations/$stationId/edit'
    | '/_authenticated/menus/$menuId/categories/$categoryId/delete'
    | '/_authenticated/menus/$menuId/categories/$categoryId/edit'
    | '/_authenticated/menus/$menuId/items/$itemId/create-sales-category'
    | '/_authenticated/menus/$menuId/items/$itemId/create-tax-category'
    | '/_authenticated/menus/$menuId/items/$itemId/delete'
    | '/_authenticated/menus/$menuId/items/new/create-sales-category'
    | '/_authenticated/menus/$menuId/items/new/create-tax-category'
    | '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/delete'
    | '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/duplicate'
    | '/_authenticated/settings/sales-categories/$id/delete/create-category'
    | '/_authenticated/settings/tax-categories/$id/delete/create-category'
    | '/_authenticated/settings/terminals/readers/$readerId/delete'
    | '/_authenticated/settings/terminals/readers/$readerId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  CreateOrganizationRoute: typeof CreateOrganizationRoute
  OnboardingRoute: typeof OnboardingRoute
  SelectOrganizationRoute: typeof SelectOrganizationRoute
  SetupRoute: typeof SetupRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-organization': {
      id: '/create-organization'
      path: '/create-organization'
      fullPath: '/create-organization'
      preLoaderRoute: typeof CreateOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-organization': {
      id: '/select-organization'
      path: '/select-organization'
      fullPath: '/select-organization'
      preLoaderRoute: typeof SelectOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/balances': {
      id: '/_authenticated/balances'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof AuthenticatedBalancesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/disputes': {
      id: '/_authenticated/disputes'
      path: '/disputes'
      fullPath: '/disputes'
      preLoaderRoute: typeof AuthenticatedDisputesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payments': {
      id: '/_authenticated/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthenticatedPaymentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payouts': {
      id: '/_authenticated/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AuthenticatedPayoutsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/': {
      id: '/_authenticated/employees/'
      path: '/'
      fullPath: '/employees/'
      preLoaderRoute: typeof AuthenticatedEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedEmployeesRoute
    }
    '/_authenticated/employees/$id': {
      id: '/_authenticated/employees/$id'
      path: '/$id'
      fullPath: '/employees/$id'
      preLoaderRoute: typeof AuthenticatedEmployeesIdRouteImport
      parentRoute: typeof AuthenticatedEmployeesRoute
    }
    '/_authenticated/employees/manage-roles': {
      id: '/_authenticated/employees/manage-roles'
      path: '/manage-roles'
      fullPath: '/employees/manage-roles'
      preLoaderRoute: typeof AuthenticatedEmployeesManageRolesRouteImport
      parentRoute: typeof AuthenticatedEmployeesRoute
    }
    '/_authenticated/employees/new': {
      id: '/_authenticated/employees/new'
      path: '/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof AuthenticatedEmployeesNewRouteImport
      parentRoute: typeof AuthenticatedEmployeesRoute
    }
    '/_authenticated/employees/shifts': {
      id: '/_authenticated/employees/shifts'
      path: '/shifts'
      fullPath: '/employees/shifts'
      preLoaderRoute: typeof AuthenticatedEmployeesShiftsRouteImport
      parentRoute: typeof AuthenticatedEmployeesRoute
    }
    '/_authenticated/locations/': {
      id: '/_authenticated/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof AuthenticatedLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/$id': {
      id: '/_authenticated/locations/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof AuthenticatedLocationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/new': {
      id: '/_authenticated/locations/new'
      path: '/locations/new'
      fullPath: '/locations/new'
      preLoaderRoute: typeof AuthenticatedLocationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/menus/': {
      id: '/_authenticated/menus/'
      path: '/menus'
      fullPath: '/menus/'
      preLoaderRoute: typeof AuthenticatedMenusIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/menus/$menuId': {
      id: '/_authenticated/menus/$menuId'
      path: '/menus/$menuId'
      fullPath: '/menus/$menuId'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/menus/empty': {
      id: '/_authenticated/menus/empty'
      path: '/menus/empty'
      fullPath: '/menus/empty'
      preLoaderRoute: typeof AuthenticatedMenusEmptyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/menus/new': {
      id: '/_authenticated/menus/new'
      path: '/menus/new'
      fullPath: '/menus/new'
      preLoaderRoute: typeof AuthenticatedMenusNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payments/$paymentId': {
      id: '/_authenticated/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof AuthenticatedPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthenticatedPaymentsRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/cash-operations': {
      id: '/_authenticated/reports/cash-operations'
      path: '/cash-operations'
      fullPath: '/reports/cash-operations'
      preLoaderRoute: typeof AuthenticatedReportsCashOperationsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/detailed-order-type-report': {
      id: '/_authenticated/reports/detailed-order-type-report'
      path: '/detailed-order-type-report'
      fullPath: '/reports/detailed-order-type-report'
      preLoaderRoute: typeof AuthenticatedReportsDetailedOrderTypeReportRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/employee-earnings-summary': {
      id: '/_authenticated/reports/employee-earnings-summary'
      path: '/employee-earnings-summary'
      fullPath: '/reports/employee-earnings-summary'
      preLoaderRoute: typeof AuthenticatedReportsEmployeeEarningsSummaryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/employee-performance': {
      id: '/_authenticated/reports/employee-performance'
      path: '/employee-performance'
      fullPath: '/reports/employee-performance'
      preLoaderRoute: typeof AuthenticatedReportsEmployeePerformanceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/employee-sales-summary': {
      id: '/_authenticated/reports/employee-sales-summary'
      path: '/employee-sales-summary'
      fullPath: '/reports/employee-sales-summary'
      preLoaderRoute: typeof AuthenticatedReportsEmployeeSalesSummaryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/employee-tip-report': {
      id: '/_authenticated/reports/employee-tip-report'
      path: '/employee-tip-report'
      fullPath: '/reports/employee-tip-report'
      preLoaderRoute: typeof AuthenticatedReportsEmployeeTipReportRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/labor-summary': {
      id: '/_authenticated/reports/labor-summary'
      path: '/labor-summary'
      fullPath: '/reports/labor-summary'
      preLoaderRoute: typeof AuthenticatedReportsLaborSummaryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/menu-performance': {
      id: '/_authenticated/reports/menu-performance'
      path: '/menu-performance'
      fullPath: '/reports/menu-performance'
      preLoaderRoute: typeof AuthenticatedReportsMenuPerformanceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/sales-by-staff-summary': {
      id: '/_authenticated/reports/sales-by-staff-summary'
      path: '/sales-by-staff-summary'
      fullPath: '/reports/sales-by-staff-summary'
      preLoaderRoute: typeof AuthenticatedReportsSalesByStaffSummaryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/tax-collected-report': {
      id: '/_authenticated/reports/tax-collected-report'
      path: '/tax-collected-report'
      fullPath: '/reports/tax-collected-report'
      preLoaderRoute: typeof AuthenticatedReportsTaxCollectedReportRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/transaction-analysis': {
      id: '/_authenticated/reports/transaction-analysis'
      path: '/transaction-analysis'
      fullPath: '/reports/transaction-analysis'
      preLoaderRoute: typeof AuthenticatedReportsTransactionAnalysisRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/account-management': {
      id: '/_authenticated/settings/account-management'
      path: '/account-management'
      fullPath: '/settings/account-management'
      preLoaderRoute: typeof AuthenticatedSettingsAccountManagementRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/business-information': {
      id: '/_authenticated/settings/business-information'
      path: '/business-information'
      fullPath: '/settings/business-information'
      preLoaderRoute: typeof AuthenticatedSettingsBusinessInformationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/menus': {
      id: '/_authenticated/settings/menus'
      path: '/menus'
      fullPath: '/settings/menus'
      preLoaderRoute: typeof AuthenticatedSettingsMenusRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/payment-account': {
      id: '/_authenticated/settings/payment-account'
      path: '/payment-account'
      fullPath: '/settings/payment-account'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/sales-categories': {
      id: '/_authenticated/settings/sales-categories'
      path: '/sales-categories'
      fullPath: '/settings/sales-categories'
      preLoaderRoute: typeof AuthenticatedSettingsSalesCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/tax-categories': {
      id: '/_authenticated/settings/tax-categories'
      path: '/tax-categories'
      fullPath: '/settings/tax-categories'
      preLoaderRoute: typeof AuthenticatedSettingsTaxCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/tax-rates': {
      id: '/_authenticated/settings/tax-rates'
      path: '/tax-rates'
      fullPath: '/settings/tax-rates'
      preLoaderRoute: typeof AuthenticatedSettingsTaxRatesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/terminals': {
      id: '/_authenticated/settings/terminals'
      path: '/terminals'
      fullPath: '/settings/terminals'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/usage': {
      id: '/_authenticated/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AuthenticatedSettingsUsageRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/employees/$id/toggle-status': {
      id: '/_authenticated/employees/$id/toggle-status'
      path: '/toggle-status'
      fullPath: '/employees/$id/toggle-status'
      preLoaderRoute: typeof AuthenticatedEmployeesIdToggleStatusRouteImport
      parentRoute: typeof AuthenticatedEmployeesIdRoute
    }
    '/_authenticated/employees/new/create-role': {
      id: '/_authenticated/employees/new/create-role'
      path: '/create-role'
      fullPath: '/employees/new/create-role'
      preLoaderRoute: typeof AuthenticatedEmployeesNewCreateRoleRouteImport
      parentRoute: typeof AuthenticatedEmployeesNewRoute
    }
    '/_authenticated/employees/shifts/new': {
      id: '/_authenticated/employees/shifts/new'
      path: '/new'
      fullPath: '/employees/shifts/new'
      preLoaderRoute: typeof AuthenticatedEmployeesShiftsNewRouteImport
      parentRoute: typeof AuthenticatedEmployeesShiftsRoute
    }
    '/_authenticated/locations/$id/devices': {
      id: '/_authenticated/locations/$id/devices'
      path: '/devices'
      fullPath: '/locations/$id/devices'
      preLoaderRoute: typeof AuthenticatedLocationsIdDevicesRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/discounts': {
      id: '/_authenticated/locations/$id/discounts'
      path: '/discounts'
      fullPath: '/locations/$id/discounts'
      preLoaderRoute: typeof AuthenticatedLocationsIdDiscountsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/edit': {
      id: '/_authenticated/locations/$id/edit'
      path: '/edit'
      fullPath: '/locations/$id/edit'
      preLoaderRoute: typeof AuthenticatedLocationsIdEditRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/end-of-day': {
      id: '/_authenticated/locations/$id/end-of-day'
      path: '/end-of-day'
      fullPath: '/locations/$id/end-of-day'
      preLoaderRoute: typeof AuthenticatedLocationsIdEndOfDayRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/kds-devices': {
      id: '/_authenticated/locations/$id/kds-devices'
      path: '/kds-devices'
      fullPath: '/locations/$id/kds-devices'
      preLoaderRoute: typeof AuthenticatedLocationsIdKdsDevicesRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/online-ordering': {
      id: '/_authenticated/locations/$id/online-ordering'
      path: '/online-ordering'
      fullPath: '/locations/$id/online-ordering'
      preLoaderRoute: typeof AuthenticatedLocationsIdOnlineOrderingRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/profile': {
      id: '/_authenticated/locations/$id/profile'
      path: '/profile'
      fullPath: '/locations/$id/profile'
      preLoaderRoute: typeof AuthenticatedLocationsIdProfileRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/receipts': {
      id: '/_authenticated/locations/$id/receipts'
      path: '/receipts'
      fullPath: '/locations/$id/receipts'
      preLoaderRoute: typeof AuthenticatedLocationsIdReceiptsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/stations': {
      id: '/_authenticated/locations/$id/stations'
      path: '/stations'
      fullPath: '/locations/$id/stations'
      preLoaderRoute: typeof AuthenticatedLocationsIdStationsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/tips': {
      id: '/_authenticated/locations/$id/tips'
      path: '/tips'
      fullPath: '/locations/$id/tips'
      preLoaderRoute: typeof AuthenticatedLocationsIdTipsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/voids-and-refunds': {
      id: '/_authenticated/locations/$id/voids-and-refunds'
      path: '/voids-and-refunds'
      fullPath: '/locations/$id/voids-and-refunds'
      preLoaderRoute: typeof AuthenticatedLocationsIdVoidsAndRefundsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/menus/$menuId/': {
      id: '/_authenticated/menus/$menuId/'
      path: '/'
      fullPath: '/menus/$menuId/'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdIndexRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/menus/$menuId/categories': {
      id: '/_authenticated/menus/$menuId/categories'
      path: '/categories'
      fullPath: '/menus/$menuId/categories'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/menus/$menuId/delete': {
      id: '/_authenticated/menus/$menuId/delete'
      path: '/delete'
      fullPath: '/menus/$menuId/delete'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdDeleteRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/menus/$menuId/edit': {
      id: '/_authenticated/menus/$menuId/edit'
      path: '/edit'
      fullPath: '/menus/$menuId/edit'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdEditRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/menus/$menuId/items': {
      id: '/_authenticated/menus/$menuId/items'
      path: '/items'
      fullPath: '/menus/$menuId/items'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/menus/$menuId/modifiers': {
      id: '/_authenticated/menus/$menuId/modifiers'
      path: '/modifiers'
      fullPath: '/menus/$menuId/modifiers'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdRoute
    }
    '/_authenticated/settings/account/$': {
      id: '/_authenticated/settings/account/$'
      path: '/account/$'
      fullPath: '/settings/account/$'
      preLoaderRoute: typeof AuthenticatedSettingsAccountSplatRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/sales-categories/new': {
      id: '/_authenticated/settings/sales-categories/new'
      path: '/new'
      fullPath: '/settings/sales-categories/new'
      preLoaderRoute: typeof AuthenticatedSettingsSalesCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesCategoriesRoute
    }
    '/_authenticated/settings/tax-categories/new': {
      id: '/_authenticated/settings/tax-categories/new'
      path: '/new'
      fullPath: '/settings/tax-categories/new'
      preLoaderRoute: typeof AuthenticatedSettingsTaxCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedSettingsTaxCategoriesRoute
    }
    '/_authenticated/employees/$id/edit/$field': {
      id: '/_authenticated/employees/$id/edit/$field'
      path: '/edit/$field'
      fullPath: '/employees/$id/edit/$field'
      preLoaderRoute: typeof AuthenticatedEmployeesIdEditFieldRouteImport
      parentRoute: typeof AuthenticatedEmployeesIdRoute
    }
    '/_authenticated/employees/shifts/$shiftId/delete': {
      id: '/_authenticated/employees/shifts/$shiftId/delete'
      path: '/$shiftId/delete'
      fullPath: '/employees/shifts/$shiftId/delete'
      preLoaderRoute: typeof AuthenticatedEmployeesShiftsShiftIdDeleteRouteImport
      parentRoute: typeof AuthenticatedEmployeesShiftsRoute
    }
    '/_authenticated/employees/shifts/$shiftId/edit': {
      id: '/_authenticated/employees/shifts/$shiftId/edit'
      path: '/$shiftId/edit'
      fullPath: '/employees/shifts/$shiftId/edit'
      preLoaderRoute: typeof AuthenticatedEmployeesShiftsShiftIdEditRouteImport
      parentRoute: typeof AuthenticatedEmployeesShiftsRoute
    }
    '/_authenticated/locations/$id/devices/$deviceId': {
      id: '/_authenticated/locations/$id/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/locations/$id/devices/$deviceId'
      preLoaderRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDevicesRoute
    }
    '/_authenticated/locations/$id/discounts/new': {
      id: '/_authenticated/locations/$id/discounts/new'
      path: '/new'
      fullPath: '/locations/$id/discounts/new'
      preLoaderRoute: typeof AuthenticatedLocationsIdDiscountsNewRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDiscountsRoute
    }
    '/_authenticated/locations/$id/discounts/settings': {
      id: '/_authenticated/locations/$id/discounts/settings'
      path: '/settings'
      fullPath: '/locations/$id/discounts/settings'
      preLoaderRoute: typeof AuthenticatedLocationsIdDiscountsSettingsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDiscountsRoute
    }
    '/_authenticated/locations/$id/end-of-day/business-report': {
      id: '/_authenticated/locations/$id/end-of-day/business-report'
      path: '/business-report'
      fullPath: '/locations/$id/end-of-day/business-report'
      preLoaderRoute: typeof AuthenticatedLocationsIdEndOfDayBusinessReportRouteImport
      parentRoute: typeof AuthenticatedLocationsIdEndOfDayRoute
    }
    '/_authenticated/locations/$id/end-of-day/employee-report': {
      id: '/_authenticated/locations/$id/end-of-day/employee-report'
      path: '/employee-report'
      fullPath: '/locations/$id/end-of-day/employee-report'
      preLoaderRoute: typeof AuthenticatedLocationsIdEndOfDayEmployeeReportRouteImport
      parentRoute: typeof AuthenticatedLocationsIdEndOfDayRoute
    }
    '/_authenticated/locations/$id/receipts/customer-bill': {
      id: '/_authenticated/locations/$id/receipts/customer-bill'
      path: '/customer-bill'
      fullPath: '/locations/$id/receipts/customer-bill'
      preLoaderRoute: typeof AuthenticatedLocationsIdReceiptsCustomerBillRouteImport
      parentRoute: typeof AuthenticatedLocationsIdReceiptsRoute
    }
    '/_authenticated/locations/$id/receipts/customer-receipt': {
      id: '/_authenticated/locations/$id/receipts/customer-receipt'
      path: '/customer-receipt'
      fullPath: '/locations/$id/receipts/customer-receipt'
      preLoaderRoute: typeof AuthenticatedLocationsIdReceiptsCustomerReceiptRouteImport
      parentRoute: typeof AuthenticatedLocationsIdReceiptsRoute
    }
    '/_authenticated/locations/$id/receipts/kitchen-ticket': {
      id: '/_authenticated/locations/$id/receipts/kitchen-ticket'
      path: '/kitchen-ticket'
      fullPath: '/locations/$id/receipts/kitchen-ticket'
      preLoaderRoute: typeof AuthenticatedLocationsIdReceiptsKitchenTicketRouteImport
      parentRoute: typeof AuthenticatedLocationsIdReceiptsRoute
    }
    '/_authenticated/locations/$id/stations/new': {
      id: '/_authenticated/locations/$id/stations/new'
      path: '/new'
      fullPath: '/locations/$id/stations/new'
      preLoaderRoute: typeof AuthenticatedLocationsIdStationsNewRouteImport
      parentRoute: typeof AuthenticatedLocationsIdStationsRoute
    }
    '/_authenticated/menus/$menuId/categories/': {
      id: '/_authenticated/menus/$menuId/categories/'
      path: '/'
      fullPath: '/menus/$menuId/categories/'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdCategoriesRoute
    }
    '/_authenticated/menus/$menuId/categories/$categoryId': {
      id: '/_authenticated/menus/$menuId/categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/menus/$menuId/categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdCategoriesRoute
    }
    '/_authenticated/menus/$menuId/categories/new': {
      id: '/_authenticated/menus/$menuId/categories/new'
      path: '/new'
      fullPath: '/menus/$menuId/categories/new'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdCategoriesRoute
    }
    '/_authenticated/menus/$menuId/items/': {
      id: '/_authenticated/menus/$menuId/items/'
      path: '/'
      fullPath: '/menus/$menuId/items/'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsIndexRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsRoute
    }
    '/_authenticated/menus/$menuId/items/$itemId': {
      id: '/_authenticated/menus/$menuId/items/$itemId'
      path: '/$itemId'
      fullPath: '/menus/$menuId/items/$itemId'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsItemIdRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsRoute
    }
    '/_authenticated/menus/$menuId/items/new': {
      id: '/_authenticated/menus/$menuId/items/new'
      path: '/new'
      fullPath: '/menus/$menuId/items/new'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsNewRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsRoute
    }
    '/_authenticated/menus/$menuId/modifiers/': {
      id: '/_authenticated/menus/$menuId/modifiers/'
      path: '/'
      fullPath: '/menus/$menuId/modifiers/'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersIndexRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdModifiersRoute
    }
    '/_authenticated/menus/$menuId/modifiers/$modifierGroupId': {
      id: '/_authenticated/menus/$menuId/modifiers/$modifierGroupId'
      path: '/$modifierGroupId'
      fullPath: '/menus/$menuId/modifiers/$modifierGroupId'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdModifiersRoute
    }
    '/_authenticated/menus/$menuId/modifiers/new': {
      id: '/_authenticated/menus/$menuId/modifiers/new'
      path: '/new'
      fullPath: '/menus/$menuId/modifiers/new'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersNewRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdModifiersRoute
    }
    '/_authenticated/settings/business-information/edit/$type': {
      id: '/_authenticated/settings/business-information/edit/$type'
      path: '/edit/$type'
      fullPath: '/settings/business-information/edit/$type'
      preLoaderRoute: typeof AuthenticatedSettingsBusinessInformationEditTypeRouteImport
      parentRoute: typeof AuthenticatedSettingsBusinessInformationRoute
    }
    '/_authenticated/settings/sales-categories/$categoryId/edit': {
      id: '/_authenticated/settings/sales-categories/$categoryId/edit'
      path: '/$categoryId/edit'
      fullPath: '/settings/sales-categories/$categoryId/edit'
      preLoaderRoute: typeof AuthenticatedSettingsSalesCategoriesCategoryIdEditRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesCategoriesRoute
    }
    '/_authenticated/settings/sales-categories/$id/delete': {
      id: '/_authenticated/settings/sales-categories/$id/delete'
      path: '/$id/delete'
      fullPath: '/settings/sales-categories/$id/delete'
      preLoaderRoute: typeof AuthenticatedSettingsSalesCategoriesIdDeleteRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesCategoriesRoute
    }
    '/_authenticated/settings/tax-categories/$categoryId/edit': {
      id: '/_authenticated/settings/tax-categories/$categoryId/edit'
      path: '/$categoryId/edit'
      fullPath: '/settings/tax-categories/$categoryId/edit'
      preLoaderRoute: typeof AuthenticatedSettingsTaxCategoriesCategoryIdEditRouteImport
      parentRoute: typeof AuthenticatedSettingsTaxCategoriesRoute
    }
    '/_authenticated/settings/tax-categories/$id/delete': {
      id: '/_authenticated/settings/tax-categories/$id/delete'
      path: '/$id/delete'
      fullPath: '/settings/tax-categories/$id/delete'
      preLoaderRoute: typeof AuthenticatedSettingsTaxCategoriesIdDeleteRouteImport
      parentRoute: typeof AuthenticatedSettingsTaxCategoriesRoute
    }
    '/_authenticated/settings/terminals/order/$locationId': {
      id: '/_authenticated/settings/terminals/order/$locationId'
      path: '/order/$locationId'
      fullPath: '/settings/terminals/order/$locationId'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsOrderLocationIdRouteImport
      parentRoute: typeof AuthenticatedSettingsTerminalsRoute
    }
    '/_authenticated/settings/terminals/register/$locationId': {
      id: '/_authenticated/settings/terminals/register/$locationId'
      path: '/register/$locationId'
      fullPath: '/settings/terminals/register/$locationId'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsRegisterLocationIdRouteImport
      parentRoute: typeof AuthenticatedSettingsTerminalsRoute
    }
    '/_authenticated/settings/terminals/setup/$locationId': {
      id: '/_authenticated/settings/terminals/setup/$locationId'
      path: '/setup/$locationId'
      fullPath: '/settings/terminals/setup/$locationId'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsSetupLocationIdRouteImport
      parentRoute: typeof AuthenticatedSettingsTerminalsRoute
    }
    '/_authenticated/locations/$id/devices/$deviceId/add-terminal': {
      id: '/_authenticated/locations/$id/devices/$deviceId/add-terminal'
      path: '/add-terminal'
      fullPath: '/locations/$id/devices/$deviceId/add-terminal'
      preLoaderRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRoute
    }
    '/_authenticated/locations/$id/devices/$deviceId/delete': {
      id: '/_authenticated/locations/$id/devices/$deviceId/delete'
      path: '/delete'
      fullPath: '/locations/$id/devices/$deviceId/delete'
      preLoaderRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdDeleteRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRoute
    }
    '/_authenticated/locations/$id/devices/$deviceId/remove-terminal': {
      id: '/_authenticated/locations/$id/devices/$deviceId/remove-terminal'
      path: '/remove-terminal'
      fullPath: '/locations/$id/devices/$deviceId/remove-terminal'
      preLoaderRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRoute
    }
    '/_authenticated/locations/$id/discounts/$discountId/delete': {
      id: '/_authenticated/locations/$id/discounts/$discountId/delete'
      path: '/$discountId/delete'
      fullPath: '/locations/$id/discounts/$discountId/delete'
      preLoaderRoute: typeof AuthenticatedLocationsIdDiscountsDiscountIdDeleteRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDiscountsRoute
    }
    '/_authenticated/locations/$id/discounts/$discountId/edit': {
      id: '/_authenticated/locations/$id/discounts/$discountId/edit'
      path: '/$discountId/edit'
      fullPath: '/locations/$id/discounts/$discountId/edit'
      preLoaderRoute: typeof AuthenticatedLocationsIdDiscountsDiscountIdEditRouteImport
      parentRoute: typeof AuthenticatedLocationsIdDiscountsRoute
    }
    '/_authenticated/locations/$id/profile/edit/$field': {
      id: '/_authenticated/locations/$id/profile/edit/$field'
      path: '/edit/$field'
      fullPath: '/locations/$id/profile/edit/$field'
      preLoaderRoute: typeof AuthenticatedLocationsIdProfileEditFieldRouteImport
      parentRoute: typeof AuthenticatedLocationsIdProfileRoute
    }
    '/_authenticated/locations/$id/stations/$stationId/edit': {
      id: '/_authenticated/locations/$id/stations/$stationId/edit'
      path: '/$stationId/edit'
      fullPath: '/locations/$id/stations/$stationId/edit'
      preLoaderRoute: typeof AuthenticatedLocationsIdStationsStationIdEditRouteImport
      parentRoute: typeof AuthenticatedLocationsIdStationsRoute
    }
    '/_authenticated/menus/$menuId/categories/$categoryId/delete': {
      id: '/_authenticated/menus/$menuId/categories/$categoryId/delete'
      path: '/delete'
      fullPath: '/menus/$menuId/categories/$categoryId/delete'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRoute
    }
    '/_authenticated/menus/$menuId/categories/$categoryId/edit': {
      id: '/_authenticated/menus/$menuId/categories/$categoryId/edit'
      path: '/edit'
      fullPath: '/menus/$menuId/categories/$categoryId/edit'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdEditRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRoute
    }
    '/_authenticated/menus/$menuId/items/$itemId/create-sales-category': {
      id: '/_authenticated/menus/$menuId/items/$itemId/create-sales-category'
      path: '/create-sales-category'
      fullPath: '/menus/$menuId/items/$itemId/create-sales-category'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsItemIdRoute
    }
    '/_authenticated/menus/$menuId/items/$itemId/create-tax-category': {
      id: '/_authenticated/menus/$menuId/items/$itemId/create-tax-category'
      path: '/create-tax-category'
      fullPath: '/menus/$menuId/items/$itemId/create-tax-category'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsItemIdRoute
    }
    '/_authenticated/menus/$menuId/items/$itemId/delete': {
      id: '/_authenticated/menus/$menuId/items/$itemId/delete'
      path: '/delete'
      fullPath: '/menus/$menuId/items/$itemId/delete'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsItemIdDeleteRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsItemIdRoute
    }
    '/_authenticated/menus/$menuId/items/new/create-sales-category': {
      id: '/_authenticated/menus/$menuId/items/new/create-sales-category'
      path: '/create-sales-category'
      fullPath: '/menus/$menuId/items/new/create-sales-category'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsNewRoute
    }
    '/_authenticated/menus/$menuId/items/new/create-tax-category': {
      id: '/_authenticated/menus/$menuId/items/new/create-tax-category'
      path: '/create-tax-category'
      fullPath: '/menus/$menuId/items/new/create-tax-category'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdItemsNewRoute
    }
    '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/delete': {
      id: '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/delete'
      path: '/delete'
      fullPath: '/menus/$menuId/modifiers/$modifierGroupId/delete'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute
    }
    '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/duplicate': {
      id: '/_authenticated/menus/$menuId/modifiers/$modifierGroupId/duplicate'
      path: '/duplicate'
      fullPath: '/menus/$menuId/modifiers/$modifierGroupId/duplicate'
      preLoaderRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute
    }
    '/_authenticated/settings/sales-categories/$id/delete/create-category': {
      id: '/_authenticated/settings/sales-categories/$id/delete/create-category'
      path: '/create-category'
      fullPath: '/settings/sales-categories/$id/delete/create-category'
      preLoaderRoute: typeof AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesCategoriesIdDeleteRoute
    }
    '/_authenticated/settings/tax-categories/$id/delete/create-category': {
      id: '/_authenticated/settings/tax-categories/$id/delete/create-category'
      path: '/create-category'
      fullPath: '/settings/tax-categories/$id/delete/create-category'
      preLoaderRoute: typeof AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRouteImport
      parentRoute: typeof AuthenticatedSettingsTaxCategoriesIdDeleteRoute
    }
    '/_authenticated/settings/terminals/readers/$readerId/delete': {
      id: '/_authenticated/settings/terminals/readers/$readerId/delete'
      path: '/readers/$readerId/delete'
      fullPath: '/settings/terminals/readers/$readerId/delete'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsReadersReaderIdDeleteRouteImport
      parentRoute: typeof AuthenticatedSettingsTerminalsRoute
    }
    '/_authenticated/settings/terminals/readers/$readerId/edit': {
      id: '/_authenticated/settings/terminals/readers/$readerId/edit'
      path: '/readers/$readerId/edit'
      fullPath: '/settings/terminals/readers/$readerId/edit'
      preLoaderRoute: typeof AuthenticatedSettingsTerminalsReadersReaderIdEditRouteImport
      parentRoute: typeof AuthenticatedSettingsTerminalsRoute
    }
  }
}

interface AuthenticatedEmployeesIdRouteChildren {
  AuthenticatedEmployeesIdToggleStatusRoute: typeof AuthenticatedEmployeesIdToggleStatusRoute
  AuthenticatedEmployeesIdEditFieldRoute: typeof AuthenticatedEmployeesIdEditFieldRoute
}

const AuthenticatedEmployeesIdRouteChildren: AuthenticatedEmployeesIdRouteChildren =
  {
    AuthenticatedEmployeesIdToggleStatusRoute:
      AuthenticatedEmployeesIdToggleStatusRoute,
    AuthenticatedEmployeesIdEditFieldRoute:
      AuthenticatedEmployeesIdEditFieldRoute,
  }

const AuthenticatedEmployeesIdRouteWithChildren =
  AuthenticatedEmployeesIdRoute._addFileChildren(
    AuthenticatedEmployeesIdRouteChildren,
  )

interface AuthenticatedEmployeesNewRouteChildren {
  AuthenticatedEmployeesNewCreateRoleRoute: typeof AuthenticatedEmployeesNewCreateRoleRoute
}

const AuthenticatedEmployeesNewRouteChildren: AuthenticatedEmployeesNewRouteChildren =
  {
    AuthenticatedEmployeesNewCreateRoleRoute:
      AuthenticatedEmployeesNewCreateRoleRoute,
  }

const AuthenticatedEmployeesNewRouteWithChildren =
  AuthenticatedEmployeesNewRoute._addFileChildren(
    AuthenticatedEmployeesNewRouteChildren,
  )

interface AuthenticatedEmployeesShiftsRouteChildren {
  AuthenticatedEmployeesShiftsNewRoute: typeof AuthenticatedEmployeesShiftsNewRoute
  AuthenticatedEmployeesShiftsShiftIdDeleteRoute: typeof AuthenticatedEmployeesShiftsShiftIdDeleteRoute
  AuthenticatedEmployeesShiftsShiftIdEditRoute: typeof AuthenticatedEmployeesShiftsShiftIdEditRoute
}

const AuthenticatedEmployeesShiftsRouteChildren: AuthenticatedEmployeesShiftsRouteChildren =
  {
    AuthenticatedEmployeesShiftsNewRoute: AuthenticatedEmployeesShiftsNewRoute,
    AuthenticatedEmployeesShiftsShiftIdDeleteRoute:
      AuthenticatedEmployeesShiftsShiftIdDeleteRoute,
    AuthenticatedEmployeesShiftsShiftIdEditRoute:
      AuthenticatedEmployeesShiftsShiftIdEditRoute,
  }

const AuthenticatedEmployeesShiftsRouteWithChildren =
  AuthenticatedEmployeesShiftsRoute._addFileChildren(
    AuthenticatedEmployeesShiftsRouteChildren,
  )

interface AuthenticatedEmployeesRouteChildren {
  AuthenticatedEmployeesIdRoute: typeof AuthenticatedEmployeesIdRouteWithChildren
  AuthenticatedEmployeesManageRolesRoute: typeof AuthenticatedEmployeesManageRolesRoute
  AuthenticatedEmployeesNewRoute: typeof AuthenticatedEmployeesNewRouteWithChildren
  AuthenticatedEmployeesShiftsRoute: typeof AuthenticatedEmployeesShiftsRouteWithChildren
  AuthenticatedEmployeesIndexRoute: typeof AuthenticatedEmployeesIndexRoute
}

const AuthenticatedEmployeesRouteChildren: AuthenticatedEmployeesRouteChildren =
  {
    AuthenticatedEmployeesIdRoute: AuthenticatedEmployeesIdRouteWithChildren,
    AuthenticatedEmployeesManageRolesRoute:
      AuthenticatedEmployeesManageRolesRoute,
    AuthenticatedEmployeesNewRoute: AuthenticatedEmployeesNewRouteWithChildren,
    AuthenticatedEmployeesShiftsRoute:
      AuthenticatedEmployeesShiftsRouteWithChildren,
    AuthenticatedEmployeesIndexRoute: AuthenticatedEmployeesIndexRoute,
  }

const AuthenticatedEmployeesRouteWithChildren =
  AuthenticatedEmployeesRoute._addFileChildren(
    AuthenticatedEmployeesRouteChildren,
  )

interface AuthenticatedPaymentsRouteChildren {
  AuthenticatedPaymentsPaymentIdRoute: typeof AuthenticatedPaymentsPaymentIdRoute
}

const AuthenticatedPaymentsRouteChildren: AuthenticatedPaymentsRouteChildren = {
  AuthenticatedPaymentsPaymentIdRoute: AuthenticatedPaymentsPaymentIdRoute,
}

const AuthenticatedPaymentsRouteWithChildren =
  AuthenticatedPaymentsRoute._addFileChildren(
    AuthenticatedPaymentsRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsCashOperationsRoute: typeof AuthenticatedReportsCashOperationsRoute
  AuthenticatedReportsDetailedOrderTypeReportRoute: typeof AuthenticatedReportsDetailedOrderTypeReportRoute
  AuthenticatedReportsEmployeeEarningsSummaryRoute: typeof AuthenticatedReportsEmployeeEarningsSummaryRoute
  AuthenticatedReportsEmployeePerformanceRoute: typeof AuthenticatedReportsEmployeePerformanceRoute
  AuthenticatedReportsEmployeeSalesSummaryRoute: typeof AuthenticatedReportsEmployeeSalesSummaryRoute
  AuthenticatedReportsEmployeeTipReportRoute: typeof AuthenticatedReportsEmployeeTipReportRoute
  AuthenticatedReportsLaborSummaryRoute: typeof AuthenticatedReportsLaborSummaryRoute
  AuthenticatedReportsMenuPerformanceRoute: typeof AuthenticatedReportsMenuPerformanceRoute
  AuthenticatedReportsSalesByStaffSummaryRoute: typeof AuthenticatedReportsSalesByStaffSummaryRoute
  AuthenticatedReportsTaxCollectedReportRoute: typeof AuthenticatedReportsTaxCollectedReportRoute
  AuthenticatedReportsTransactionAnalysisRoute: typeof AuthenticatedReportsTransactionAnalysisRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsCashOperationsRoute:
    AuthenticatedReportsCashOperationsRoute,
  AuthenticatedReportsDetailedOrderTypeReportRoute:
    AuthenticatedReportsDetailedOrderTypeReportRoute,
  AuthenticatedReportsEmployeeEarningsSummaryRoute:
    AuthenticatedReportsEmployeeEarningsSummaryRoute,
  AuthenticatedReportsEmployeePerformanceRoute:
    AuthenticatedReportsEmployeePerformanceRoute,
  AuthenticatedReportsEmployeeSalesSummaryRoute:
    AuthenticatedReportsEmployeeSalesSummaryRoute,
  AuthenticatedReportsEmployeeTipReportRoute:
    AuthenticatedReportsEmployeeTipReportRoute,
  AuthenticatedReportsLaborSummaryRoute: AuthenticatedReportsLaborSummaryRoute,
  AuthenticatedReportsMenuPerformanceRoute:
    AuthenticatedReportsMenuPerformanceRoute,
  AuthenticatedReportsSalesByStaffSummaryRoute:
    AuthenticatedReportsSalesByStaffSummaryRoute,
  AuthenticatedReportsTaxCollectedReportRoute:
    AuthenticatedReportsTaxCollectedReportRoute,
  AuthenticatedReportsTransactionAnalysisRoute:
    AuthenticatedReportsTransactionAnalysisRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSettingsBusinessInformationRouteChildren {
  AuthenticatedSettingsBusinessInformationEditTypeRoute: typeof AuthenticatedSettingsBusinessInformationEditTypeRoute
}

const AuthenticatedSettingsBusinessInformationRouteChildren: AuthenticatedSettingsBusinessInformationRouteChildren =
  {
    AuthenticatedSettingsBusinessInformationEditTypeRoute:
      AuthenticatedSettingsBusinessInformationEditTypeRoute,
  }

const AuthenticatedSettingsBusinessInformationRouteWithChildren =
  AuthenticatedSettingsBusinessInformationRoute._addFileChildren(
    AuthenticatedSettingsBusinessInformationRouteChildren,
  )

interface AuthenticatedSettingsSalesCategoriesIdDeleteRouteChildren {
  AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute: typeof AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute
}

const AuthenticatedSettingsSalesCategoriesIdDeleteRouteChildren: AuthenticatedSettingsSalesCategoriesIdDeleteRouteChildren =
  {
    AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute:
      AuthenticatedSettingsSalesCategoriesIdDeleteCreateCategoryRoute,
  }

const AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren =
  AuthenticatedSettingsSalesCategoriesIdDeleteRoute._addFileChildren(
    AuthenticatedSettingsSalesCategoriesIdDeleteRouteChildren,
  )

interface AuthenticatedSettingsSalesCategoriesRouteChildren {
  AuthenticatedSettingsSalesCategoriesNewRoute: typeof AuthenticatedSettingsSalesCategoriesNewRoute
  AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute: typeof AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute
  AuthenticatedSettingsSalesCategoriesIdDeleteRoute: typeof AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren
}

const AuthenticatedSettingsSalesCategoriesRouteChildren: AuthenticatedSettingsSalesCategoriesRouteChildren =
  {
    AuthenticatedSettingsSalesCategoriesNewRoute:
      AuthenticatedSettingsSalesCategoriesNewRoute,
    AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute:
      AuthenticatedSettingsSalesCategoriesCategoryIdEditRoute,
    AuthenticatedSettingsSalesCategoriesIdDeleteRoute:
      AuthenticatedSettingsSalesCategoriesIdDeleteRouteWithChildren,
  }

const AuthenticatedSettingsSalesCategoriesRouteWithChildren =
  AuthenticatedSettingsSalesCategoriesRoute._addFileChildren(
    AuthenticatedSettingsSalesCategoriesRouteChildren,
  )

interface AuthenticatedSettingsTaxCategoriesIdDeleteRouteChildren {
  AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute: typeof AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute
}

const AuthenticatedSettingsTaxCategoriesIdDeleteRouteChildren: AuthenticatedSettingsTaxCategoriesIdDeleteRouteChildren =
  {
    AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute:
      AuthenticatedSettingsTaxCategoriesIdDeleteCreateCategoryRoute,
  }

const AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren =
  AuthenticatedSettingsTaxCategoriesIdDeleteRoute._addFileChildren(
    AuthenticatedSettingsTaxCategoriesIdDeleteRouteChildren,
  )

interface AuthenticatedSettingsTaxCategoriesRouteChildren {
  AuthenticatedSettingsTaxCategoriesNewRoute: typeof AuthenticatedSettingsTaxCategoriesNewRoute
  AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute: typeof AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute
  AuthenticatedSettingsTaxCategoriesIdDeleteRoute: typeof AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren
}

const AuthenticatedSettingsTaxCategoriesRouteChildren: AuthenticatedSettingsTaxCategoriesRouteChildren =
  {
    AuthenticatedSettingsTaxCategoriesNewRoute:
      AuthenticatedSettingsTaxCategoriesNewRoute,
    AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute:
      AuthenticatedSettingsTaxCategoriesCategoryIdEditRoute,
    AuthenticatedSettingsTaxCategoriesIdDeleteRoute:
      AuthenticatedSettingsTaxCategoriesIdDeleteRouteWithChildren,
  }

const AuthenticatedSettingsTaxCategoriesRouteWithChildren =
  AuthenticatedSettingsTaxCategoriesRoute._addFileChildren(
    AuthenticatedSettingsTaxCategoriesRouteChildren,
  )

interface AuthenticatedSettingsTerminalsRouteChildren {
  AuthenticatedSettingsTerminalsOrderLocationIdRoute: typeof AuthenticatedSettingsTerminalsOrderLocationIdRoute
  AuthenticatedSettingsTerminalsRegisterLocationIdRoute: typeof AuthenticatedSettingsTerminalsRegisterLocationIdRoute
  AuthenticatedSettingsTerminalsSetupLocationIdRoute: typeof AuthenticatedSettingsTerminalsSetupLocationIdRoute
  AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute: typeof AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute
  AuthenticatedSettingsTerminalsReadersReaderIdEditRoute: typeof AuthenticatedSettingsTerminalsReadersReaderIdEditRoute
}

const AuthenticatedSettingsTerminalsRouteChildren: AuthenticatedSettingsTerminalsRouteChildren =
  {
    AuthenticatedSettingsTerminalsOrderLocationIdRoute:
      AuthenticatedSettingsTerminalsOrderLocationIdRoute,
    AuthenticatedSettingsTerminalsRegisterLocationIdRoute:
      AuthenticatedSettingsTerminalsRegisterLocationIdRoute,
    AuthenticatedSettingsTerminalsSetupLocationIdRoute:
      AuthenticatedSettingsTerminalsSetupLocationIdRoute,
    AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute:
      AuthenticatedSettingsTerminalsReadersReaderIdDeleteRoute,
    AuthenticatedSettingsTerminalsReadersReaderIdEditRoute:
      AuthenticatedSettingsTerminalsReadersReaderIdEditRoute,
  }

const AuthenticatedSettingsTerminalsRouteWithChildren =
  AuthenticatedSettingsTerminalsRoute._addFileChildren(
    AuthenticatedSettingsTerminalsRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccountManagementRoute: typeof AuthenticatedSettingsAccountManagementRoute
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsBusinessInformationRoute: typeof AuthenticatedSettingsBusinessInformationRouteWithChildren
  AuthenticatedSettingsMenusRoute: typeof AuthenticatedSettingsMenusRoute
  AuthenticatedSettingsOrganizationRoute: typeof AuthenticatedSettingsOrganizationRoute
  AuthenticatedSettingsPaymentAccountRoute: typeof AuthenticatedSettingsPaymentAccountRoute
  AuthenticatedSettingsSalesCategoriesRoute: typeof AuthenticatedSettingsSalesCategoriesRouteWithChildren
  AuthenticatedSettingsTaxCategoriesRoute: typeof AuthenticatedSettingsTaxCategoriesRouteWithChildren
  AuthenticatedSettingsTaxRatesRoute: typeof AuthenticatedSettingsTaxRatesRoute
  AuthenticatedSettingsTerminalsRoute: typeof AuthenticatedSettingsTerminalsRouteWithChildren
  AuthenticatedSettingsUsageRoute: typeof AuthenticatedSettingsUsageRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsAccountSplatRoute: typeof AuthenticatedSettingsAccountSplatRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountManagementRoute:
    AuthenticatedSettingsAccountManagementRoute,
  AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
  AuthenticatedSettingsBusinessInformationRoute:
    AuthenticatedSettingsBusinessInformationRouteWithChildren,
  AuthenticatedSettingsMenusRoute: AuthenticatedSettingsMenusRoute,
  AuthenticatedSettingsOrganizationRoute:
    AuthenticatedSettingsOrganizationRoute,
  AuthenticatedSettingsPaymentAccountRoute:
    AuthenticatedSettingsPaymentAccountRoute,
  AuthenticatedSettingsSalesCategoriesRoute:
    AuthenticatedSettingsSalesCategoriesRouteWithChildren,
  AuthenticatedSettingsTaxCategoriesRoute:
    AuthenticatedSettingsTaxCategoriesRouteWithChildren,
  AuthenticatedSettingsTaxRatesRoute: AuthenticatedSettingsTaxRatesRoute,
  AuthenticatedSettingsTerminalsRoute:
    AuthenticatedSettingsTerminalsRouteWithChildren,
  AuthenticatedSettingsUsageRoute: AuthenticatedSettingsUsageRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsAccountSplatRoute:
    AuthenticatedSettingsAccountSplatRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedLocationsIdDevicesDeviceIdRouteChildren {
  AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute
  AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute
  AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute
}

const AuthenticatedLocationsIdDevicesDeviceIdRouteChildren: AuthenticatedLocationsIdDevicesDeviceIdRouteChildren =
  {
    AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute:
      AuthenticatedLocationsIdDevicesDeviceIdAddTerminalRoute,
    AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute:
      AuthenticatedLocationsIdDevicesDeviceIdDeleteRoute,
    AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute:
      AuthenticatedLocationsIdDevicesDeviceIdRemoveTerminalRoute,
  }

const AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren =
  AuthenticatedLocationsIdDevicesDeviceIdRoute._addFileChildren(
    AuthenticatedLocationsIdDevicesDeviceIdRouteChildren,
  )

interface AuthenticatedLocationsIdDevicesRouteChildren {
  AuthenticatedLocationsIdDevicesDeviceIdRoute: typeof AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren
}

const AuthenticatedLocationsIdDevicesRouteChildren: AuthenticatedLocationsIdDevicesRouteChildren =
  {
    AuthenticatedLocationsIdDevicesDeviceIdRoute:
      AuthenticatedLocationsIdDevicesDeviceIdRouteWithChildren,
  }

const AuthenticatedLocationsIdDevicesRouteWithChildren =
  AuthenticatedLocationsIdDevicesRoute._addFileChildren(
    AuthenticatedLocationsIdDevicesRouteChildren,
  )

interface AuthenticatedLocationsIdDiscountsRouteChildren {
  AuthenticatedLocationsIdDiscountsNewRoute: typeof AuthenticatedLocationsIdDiscountsNewRoute
  AuthenticatedLocationsIdDiscountsSettingsRoute: typeof AuthenticatedLocationsIdDiscountsSettingsRoute
  AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute: typeof AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute
  AuthenticatedLocationsIdDiscountsDiscountIdEditRoute: typeof AuthenticatedLocationsIdDiscountsDiscountIdEditRoute
}

const AuthenticatedLocationsIdDiscountsRouteChildren: AuthenticatedLocationsIdDiscountsRouteChildren =
  {
    AuthenticatedLocationsIdDiscountsNewRoute:
      AuthenticatedLocationsIdDiscountsNewRoute,
    AuthenticatedLocationsIdDiscountsSettingsRoute:
      AuthenticatedLocationsIdDiscountsSettingsRoute,
    AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute:
      AuthenticatedLocationsIdDiscountsDiscountIdDeleteRoute,
    AuthenticatedLocationsIdDiscountsDiscountIdEditRoute:
      AuthenticatedLocationsIdDiscountsDiscountIdEditRoute,
  }

const AuthenticatedLocationsIdDiscountsRouteWithChildren =
  AuthenticatedLocationsIdDiscountsRoute._addFileChildren(
    AuthenticatedLocationsIdDiscountsRouteChildren,
  )

interface AuthenticatedLocationsIdEndOfDayRouteChildren {
  AuthenticatedLocationsIdEndOfDayBusinessReportRoute: typeof AuthenticatedLocationsIdEndOfDayBusinessReportRoute
  AuthenticatedLocationsIdEndOfDayEmployeeReportRoute: typeof AuthenticatedLocationsIdEndOfDayEmployeeReportRoute
}

const AuthenticatedLocationsIdEndOfDayRouteChildren: AuthenticatedLocationsIdEndOfDayRouteChildren =
  {
    AuthenticatedLocationsIdEndOfDayBusinessReportRoute:
      AuthenticatedLocationsIdEndOfDayBusinessReportRoute,
    AuthenticatedLocationsIdEndOfDayEmployeeReportRoute:
      AuthenticatedLocationsIdEndOfDayEmployeeReportRoute,
  }

const AuthenticatedLocationsIdEndOfDayRouteWithChildren =
  AuthenticatedLocationsIdEndOfDayRoute._addFileChildren(
    AuthenticatedLocationsIdEndOfDayRouteChildren,
  )

interface AuthenticatedLocationsIdProfileRouteChildren {
  AuthenticatedLocationsIdProfileEditFieldRoute: typeof AuthenticatedLocationsIdProfileEditFieldRoute
}

const AuthenticatedLocationsIdProfileRouteChildren: AuthenticatedLocationsIdProfileRouteChildren =
  {
    AuthenticatedLocationsIdProfileEditFieldRoute:
      AuthenticatedLocationsIdProfileEditFieldRoute,
  }

const AuthenticatedLocationsIdProfileRouteWithChildren =
  AuthenticatedLocationsIdProfileRoute._addFileChildren(
    AuthenticatedLocationsIdProfileRouteChildren,
  )

interface AuthenticatedLocationsIdReceiptsRouteChildren {
  AuthenticatedLocationsIdReceiptsCustomerBillRoute: typeof AuthenticatedLocationsIdReceiptsCustomerBillRoute
  AuthenticatedLocationsIdReceiptsCustomerReceiptRoute: typeof AuthenticatedLocationsIdReceiptsCustomerReceiptRoute
  AuthenticatedLocationsIdReceiptsKitchenTicketRoute: typeof AuthenticatedLocationsIdReceiptsKitchenTicketRoute
}

const AuthenticatedLocationsIdReceiptsRouteChildren: AuthenticatedLocationsIdReceiptsRouteChildren =
  {
    AuthenticatedLocationsIdReceiptsCustomerBillRoute:
      AuthenticatedLocationsIdReceiptsCustomerBillRoute,
    AuthenticatedLocationsIdReceiptsCustomerReceiptRoute:
      AuthenticatedLocationsIdReceiptsCustomerReceiptRoute,
    AuthenticatedLocationsIdReceiptsKitchenTicketRoute:
      AuthenticatedLocationsIdReceiptsKitchenTicketRoute,
  }

const AuthenticatedLocationsIdReceiptsRouteWithChildren =
  AuthenticatedLocationsIdReceiptsRoute._addFileChildren(
    AuthenticatedLocationsIdReceiptsRouteChildren,
  )

interface AuthenticatedLocationsIdStationsRouteChildren {
  AuthenticatedLocationsIdStationsNewRoute: typeof AuthenticatedLocationsIdStationsNewRoute
  AuthenticatedLocationsIdStationsStationIdEditRoute: typeof AuthenticatedLocationsIdStationsStationIdEditRoute
}

const AuthenticatedLocationsIdStationsRouteChildren: AuthenticatedLocationsIdStationsRouteChildren =
  {
    AuthenticatedLocationsIdStationsNewRoute:
      AuthenticatedLocationsIdStationsNewRoute,
    AuthenticatedLocationsIdStationsStationIdEditRoute:
      AuthenticatedLocationsIdStationsStationIdEditRoute,
  }

const AuthenticatedLocationsIdStationsRouteWithChildren =
  AuthenticatedLocationsIdStationsRoute._addFileChildren(
    AuthenticatedLocationsIdStationsRouteChildren,
  )

interface AuthenticatedLocationsIdRouteChildren {
  AuthenticatedLocationsIdDevicesRoute: typeof AuthenticatedLocationsIdDevicesRouteWithChildren
  AuthenticatedLocationsIdDiscountsRoute: typeof AuthenticatedLocationsIdDiscountsRouteWithChildren
  AuthenticatedLocationsIdEditRoute: typeof AuthenticatedLocationsIdEditRoute
  AuthenticatedLocationsIdEndOfDayRoute: typeof AuthenticatedLocationsIdEndOfDayRouteWithChildren
  AuthenticatedLocationsIdKdsDevicesRoute: typeof AuthenticatedLocationsIdKdsDevicesRoute
  AuthenticatedLocationsIdOnlineOrderingRoute: typeof AuthenticatedLocationsIdOnlineOrderingRoute
  AuthenticatedLocationsIdProfileRoute: typeof AuthenticatedLocationsIdProfileRouteWithChildren
  AuthenticatedLocationsIdReceiptsRoute: typeof AuthenticatedLocationsIdReceiptsRouteWithChildren
  AuthenticatedLocationsIdStationsRoute: typeof AuthenticatedLocationsIdStationsRouteWithChildren
  AuthenticatedLocationsIdTipsRoute: typeof AuthenticatedLocationsIdTipsRoute
  AuthenticatedLocationsIdVoidsAndRefundsRoute: typeof AuthenticatedLocationsIdVoidsAndRefundsRoute
}

const AuthenticatedLocationsIdRouteChildren: AuthenticatedLocationsIdRouteChildren =
  {
    AuthenticatedLocationsIdDevicesRoute:
      AuthenticatedLocationsIdDevicesRouteWithChildren,
    AuthenticatedLocationsIdDiscountsRoute:
      AuthenticatedLocationsIdDiscountsRouteWithChildren,
    AuthenticatedLocationsIdEditRoute: AuthenticatedLocationsIdEditRoute,
    AuthenticatedLocationsIdEndOfDayRoute:
      AuthenticatedLocationsIdEndOfDayRouteWithChildren,
    AuthenticatedLocationsIdKdsDevicesRoute:
      AuthenticatedLocationsIdKdsDevicesRoute,
    AuthenticatedLocationsIdOnlineOrderingRoute:
      AuthenticatedLocationsIdOnlineOrderingRoute,
    AuthenticatedLocationsIdProfileRoute:
      AuthenticatedLocationsIdProfileRouteWithChildren,
    AuthenticatedLocationsIdReceiptsRoute:
      AuthenticatedLocationsIdReceiptsRouteWithChildren,
    AuthenticatedLocationsIdStationsRoute:
      AuthenticatedLocationsIdStationsRouteWithChildren,
    AuthenticatedLocationsIdTipsRoute: AuthenticatedLocationsIdTipsRoute,
    AuthenticatedLocationsIdVoidsAndRefundsRoute:
      AuthenticatedLocationsIdVoidsAndRefundsRoute,
  }

const AuthenticatedLocationsIdRouteWithChildren =
  AuthenticatedLocationsIdRoute._addFileChildren(
    AuthenticatedLocationsIdRouteChildren,
  )

interface AuthenticatedMenusMenuIdCategoriesCategoryIdRouteChildren {
  AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute
  AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute
}

const AuthenticatedMenusMenuIdCategoriesCategoryIdRouteChildren: AuthenticatedMenusMenuIdCategoriesCategoryIdRouteChildren =
  {
    AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute:
      AuthenticatedMenusMenuIdCategoriesCategoryIdDeleteRoute,
    AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute:
      AuthenticatedMenusMenuIdCategoriesCategoryIdEditRoute,
  }

const AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren =
  AuthenticatedMenusMenuIdCategoriesCategoryIdRoute._addFileChildren(
    AuthenticatedMenusMenuIdCategoriesCategoryIdRouteChildren,
  )

interface AuthenticatedMenusMenuIdCategoriesRouteChildren {
  AuthenticatedMenusMenuIdCategoriesCategoryIdRoute: typeof AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren
  AuthenticatedMenusMenuIdCategoriesNewRoute: typeof AuthenticatedMenusMenuIdCategoriesNewRoute
  AuthenticatedMenusMenuIdCategoriesIndexRoute: typeof AuthenticatedMenusMenuIdCategoriesIndexRoute
}

const AuthenticatedMenusMenuIdCategoriesRouteChildren: AuthenticatedMenusMenuIdCategoriesRouteChildren =
  {
    AuthenticatedMenusMenuIdCategoriesCategoryIdRoute:
      AuthenticatedMenusMenuIdCategoriesCategoryIdRouteWithChildren,
    AuthenticatedMenusMenuIdCategoriesNewRoute:
      AuthenticatedMenusMenuIdCategoriesNewRoute,
    AuthenticatedMenusMenuIdCategoriesIndexRoute:
      AuthenticatedMenusMenuIdCategoriesIndexRoute,
  }

const AuthenticatedMenusMenuIdCategoriesRouteWithChildren =
  AuthenticatedMenusMenuIdCategoriesRoute._addFileChildren(
    AuthenticatedMenusMenuIdCategoriesRouteChildren,
  )

interface AuthenticatedMenusMenuIdItemsItemIdRouteChildren {
  AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute: typeof AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute
  AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute: typeof AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute
  AuthenticatedMenusMenuIdItemsItemIdDeleteRoute: typeof AuthenticatedMenusMenuIdItemsItemIdDeleteRoute
}

const AuthenticatedMenusMenuIdItemsItemIdRouteChildren: AuthenticatedMenusMenuIdItemsItemIdRouteChildren =
  {
    AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute:
      AuthenticatedMenusMenuIdItemsItemIdCreateSalesCategoryRoute,
    AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute:
      AuthenticatedMenusMenuIdItemsItemIdCreateTaxCategoryRoute,
    AuthenticatedMenusMenuIdItemsItemIdDeleteRoute:
      AuthenticatedMenusMenuIdItemsItemIdDeleteRoute,
  }

const AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren =
  AuthenticatedMenusMenuIdItemsItemIdRoute._addFileChildren(
    AuthenticatedMenusMenuIdItemsItemIdRouteChildren,
  )

interface AuthenticatedMenusMenuIdItemsNewRouteChildren {
  AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute: typeof AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute
  AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute: typeof AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute
}

const AuthenticatedMenusMenuIdItemsNewRouteChildren: AuthenticatedMenusMenuIdItemsNewRouteChildren =
  {
    AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute:
      AuthenticatedMenusMenuIdItemsNewCreateSalesCategoryRoute,
    AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute:
      AuthenticatedMenusMenuIdItemsNewCreateTaxCategoryRoute,
  }

const AuthenticatedMenusMenuIdItemsNewRouteWithChildren =
  AuthenticatedMenusMenuIdItemsNewRoute._addFileChildren(
    AuthenticatedMenusMenuIdItemsNewRouteChildren,
  )

interface AuthenticatedMenusMenuIdItemsRouteChildren {
  AuthenticatedMenusMenuIdItemsItemIdRoute: typeof AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren
  AuthenticatedMenusMenuIdItemsNewRoute: typeof AuthenticatedMenusMenuIdItemsNewRouteWithChildren
  AuthenticatedMenusMenuIdItemsIndexRoute: typeof AuthenticatedMenusMenuIdItemsIndexRoute
}

const AuthenticatedMenusMenuIdItemsRouteChildren: AuthenticatedMenusMenuIdItemsRouteChildren =
  {
    AuthenticatedMenusMenuIdItemsItemIdRoute:
      AuthenticatedMenusMenuIdItemsItemIdRouteWithChildren,
    AuthenticatedMenusMenuIdItemsNewRoute:
      AuthenticatedMenusMenuIdItemsNewRouteWithChildren,
    AuthenticatedMenusMenuIdItemsIndexRoute:
      AuthenticatedMenusMenuIdItemsIndexRoute,
  }

const AuthenticatedMenusMenuIdItemsRouteWithChildren =
  AuthenticatedMenusMenuIdItemsRoute._addFileChildren(
    AuthenticatedMenusMenuIdItemsRouteChildren,
  )

interface AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteChildren {
  AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute
  AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute
}

const AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteChildren: AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteChildren =
  {
    AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute:
      AuthenticatedMenusMenuIdModifiersModifierGroupIdDeleteRoute,
    AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute:
      AuthenticatedMenusMenuIdModifiersModifierGroupIdDuplicateRoute,
  }

const AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren =
  AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute._addFileChildren(
    AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteChildren,
  )

interface AuthenticatedMenusMenuIdModifiersRouteChildren {
  AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute: typeof AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren
  AuthenticatedMenusMenuIdModifiersNewRoute: typeof AuthenticatedMenusMenuIdModifiersNewRoute
  AuthenticatedMenusMenuIdModifiersIndexRoute: typeof AuthenticatedMenusMenuIdModifiersIndexRoute
}

const AuthenticatedMenusMenuIdModifiersRouteChildren: AuthenticatedMenusMenuIdModifiersRouteChildren =
  {
    AuthenticatedMenusMenuIdModifiersModifierGroupIdRoute:
      AuthenticatedMenusMenuIdModifiersModifierGroupIdRouteWithChildren,
    AuthenticatedMenusMenuIdModifiersNewRoute:
      AuthenticatedMenusMenuIdModifiersNewRoute,
    AuthenticatedMenusMenuIdModifiersIndexRoute:
      AuthenticatedMenusMenuIdModifiersIndexRoute,
  }

const AuthenticatedMenusMenuIdModifiersRouteWithChildren =
  AuthenticatedMenusMenuIdModifiersRoute._addFileChildren(
    AuthenticatedMenusMenuIdModifiersRouteChildren,
  )

interface AuthenticatedMenusMenuIdRouteChildren {
  AuthenticatedMenusMenuIdCategoriesRoute: typeof AuthenticatedMenusMenuIdCategoriesRouteWithChildren
  AuthenticatedMenusMenuIdDeleteRoute: typeof AuthenticatedMenusMenuIdDeleteRoute
  AuthenticatedMenusMenuIdEditRoute: typeof AuthenticatedMenusMenuIdEditRoute
  AuthenticatedMenusMenuIdItemsRoute: typeof AuthenticatedMenusMenuIdItemsRouteWithChildren
  AuthenticatedMenusMenuIdModifiersRoute: typeof AuthenticatedMenusMenuIdModifiersRouteWithChildren
  AuthenticatedMenusMenuIdIndexRoute: typeof AuthenticatedMenusMenuIdIndexRoute
}

const AuthenticatedMenusMenuIdRouteChildren: AuthenticatedMenusMenuIdRouteChildren =
  {
    AuthenticatedMenusMenuIdCategoriesRoute:
      AuthenticatedMenusMenuIdCategoriesRouteWithChildren,
    AuthenticatedMenusMenuIdDeleteRoute: AuthenticatedMenusMenuIdDeleteRoute,
    AuthenticatedMenusMenuIdEditRoute: AuthenticatedMenusMenuIdEditRoute,
    AuthenticatedMenusMenuIdItemsRoute:
      AuthenticatedMenusMenuIdItemsRouteWithChildren,
    AuthenticatedMenusMenuIdModifiersRoute:
      AuthenticatedMenusMenuIdModifiersRouteWithChildren,
    AuthenticatedMenusMenuIdIndexRoute: AuthenticatedMenusMenuIdIndexRoute,
  }

const AuthenticatedMenusMenuIdRouteWithChildren =
  AuthenticatedMenusMenuIdRoute._addFileChildren(
    AuthenticatedMenusMenuIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedBalancesRoute: typeof AuthenticatedBalancesRoute
  AuthenticatedDisputesRoute: typeof AuthenticatedDisputesRoute
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRoute
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRouteWithChildren
  AuthenticatedPaymentsRoute: typeof AuthenticatedPaymentsRouteWithChildren
  AuthenticatedPayoutsRoute: typeof AuthenticatedPayoutsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedLocationsIdRoute: typeof AuthenticatedLocationsIdRouteWithChildren
  AuthenticatedLocationsNewRoute: typeof AuthenticatedLocationsNewRoute
  AuthenticatedMenusMenuIdRoute: typeof AuthenticatedMenusMenuIdRouteWithChildren
  AuthenticatedMenusEmptyRoute: typeof AuthenticatedMenusEmptyRoute
  AuthenticatedMenusNewRoute: typeof AuthenticatedMenusNewRoute
  AuthenticatedLocationsIndexRoute: typeof AuthenticatedLocationsIndexRoute
  AuthenticatedMenusIndexRoute: typeof AuthenticatedMenusIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedBalancesRoute: AuthenticatedBalancesRoute,
  AuthenticatedDisputesRoute: AuthenticatedDisputesRoute,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRouteWithChildren,
  AuthenticatedPaymentsRoute: AuthenticatedPaymentsRouteWithChildren,
  AuthenticatedPayoutsRoute: AuthenticatedPayoutsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedLocationsIdRoute: AuthenticatedLocationsIdRouteWithChildren,
  AuthenticatedLocationsNewRoute: AuthenticatedLocationsNewRoute,
  AuthenticatedMenusMenuIdRoute: AuthenticatedMenusMenuIdRouteWithChildren,
  AuthenticatedMenusEmptyRoute: AuthenticatedMenusEmptyRoute,
  AuthenticatedMenusNewRoute: AuthenticatedMenusNewRoute,
  AuthenticatedLocationsIndexRoute: AuthenticatedLocationsIndexRoute,
  AuthenticatedMenusIndexRoute: AuthenticatedMenusIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  CreateOrganizationRoute: CreateOrganizationRoute,
  OnboardingRoute: OnboardingRoute,
  SelectOrganizationRoute: SelectOrganizationRoute,
  SetupRoute: SetupRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
